import React, { useEffect, useState } from "react";
import EmpTable from "./TablesData";
import EmpTableData from "./TableDataCode";
import EssentialTables from "./EssentialTables";
import TablecolSpan from "./TablecolSpan";
import Tables from "./Tables";
import { get, put } from "../../../../utils/api";
import EastIcon from "@mui/icons-material/East";
import BRSRFile from "../../../Common/BRSRFile";
import {
  Typography,
  Box,
  TextField,
  RadioGroup,
  Radio,
  FormControlLabel,
  Button,
} from "@mui/material";
import { useParams } from "react-router-dom";
import ReviewBox from "../../../Common/ReviewBox";
import { brsrReview, reviewBRSR } from "../../../../utils/companyId";
import { currentYear } from "../../../../utils/generateYearRanges";

const EssentialIndicator = ({
  onSave,
  hide,
  removeUpload = false,
  downloadMode = false,
}) => {
  const { id } = useParams();
  const [errors, setErrors] = useState({});
  const [rowindex, setRowIndex] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const [modalupload, setModalUpload] = useState({
    wellBeingMeasuresAndWorkersDoc: false,
    retirementBenefitsDoc: false,
    accessibilityUnderRPWD2016Doc: false,
    rightsOfPersonsDisability2016Doc: false,
    returnAndRetentionParentalLeaveDoc: false,
    grievanceRedressalMechanismDoc: false,
    membershipInAssociationsOrUnionsDoc: false,
    trainingDetailsDoc: false,
    performanceAndCareerReviewsDoc: false,
    healthAndSafetyManagementDoc: false,
    safetyIncidentsDoc: false,
    ssafetyMeasuresDoc: false,
    complaintsMadeByEmployeesAndWorkersDoc: false,
    assessmentYearDoc: false,
    healthAndSafetyPracticesWorkingDoc: false,
  });
  const [formData, setFormData] = useState({
    type: "SectionC",
    wellBeingMeasures: {
      maleEmployees: {
        permanentEmployees: "",
        otherEmployees: "",
      },
      femaleEmployees: {
        permanentEmployees: "",
        otherEmployees: "",
      },
      permanentEmployees: {
        healthInsurance: {
          male: "",
          malePercentage: "",
          female: "",
          femalePercentage: "",
        },
        accidentInsurance: {
          male: "",
          malePercentage: "",
          female: "",
          femalePercentage: "",
        },
        maternityBenefits: {
          male: "",
          malePercentage: "",
          female: "",
          femalePercentage: "",
        },
        paternityBenefits: {
          male: "",
          malePercentage: "",
          female: "",
          femalePercentage: "",
        },
        dayCareFacilities: {
          male: "",
          malePercentage: "",
          female: "",
          femalePercentage: "",
        },
        // Total: {
        //   male: "",
        //   malePercentage: "",
        //   female: "",
        //   femalePercentage: "",
        // },
      },
      otherEmployees: {
        healthInsurance: {
          male: "",
          malePercentage: "",
          female: "",
          femalePercentage: "",
        },
        accidentInsurance: {
          male: "",
          malePercentage: "",
          female: "",
          femalePercentage: "",
        },
        maternityBenefits: {
          male: "",
          malePercentage: "",
          female: "",
          femalePercentage: "",
        },
        paternityBenefits: {
          male: "",
          malePercentage: "",
          female: "",
          femalePercentage: "",
        },
        dayCareFacilities: {
          male: "",
          malePercentage: "",
          female: "",
          femalePercentage: "",
        },
        // Total: {
        //   male: "",
        //   malePercentage: "",
        //   female: "",
        //   femalePercentage: "",
        // },
      },
    },
    // wellBeingMeasuresCurrent: "",
    // wellBeingMeasuresPrevious: "",
    wellBeingWorkers: {
      maleEmployees: {
        permanentWorkers: "",
        otherWorkers: "",
      },
      femaleEmployees: {
        permanentWorkers: "",
        otherWorkers: "",
      },
      permanentWorkers: {
        healthInsurance: {
          male: "",
          malePercentage: "",
          female: "",
          femalePercentage: "",
        },
        accidentInsurance: {
          male: "",
          malePercentage: "",
          female: "",
          femalePercentage: "",
        },
        maternityBenefits: {
          male: "",
          malePercentage: "",
          female: "",
          femalePercentage: "",
        },
        paternityBenefits: {
          male: "",
          malePercentage: "",
          female: "",
          femalePercentage: "",
        },
        dayCareFacilities: {
          male: "",
          malePercentage: "",
          female: "",
          femalePercentage: "",
        },
        // Total: {
        //   male: "",
        //   malePercentage: "",
        //   female: "",
        //   femalePercentage: "",
        // },
      },
      otherWorkers: {
        healthInsurance: {
          male: "",
          malePercentage: "",
          female: "",
          femalePercentage: "",
        },
        accidentInsurance: {
          male: "",
          malePercentage: "",
          female: "",
          femalePercentage: "",
        },
        maternityBenefits: {
          male: "",
          malePercentage: "",
          female: "",
          femalePercentage: "",
        },
        paternityBenefits: {
          male: "",
          malePercentage: "",
          female: "",
          femalePercentage: "",
        },
        dayCareFacilities: {
          male: "",
          malePercentage: "",
          female: "",
          femalePercentage: "",
        },
        Total: {
          male: "",
          malePercentage: "",
          female: "",
          femalePercentage: "",
        },
      },
    },
    retirementBenefits: {
      currentFinancialYear: {
        pf: {
          employeesCovered: "",
          workersCovered: "",
          deductedDeposited: "",
        },
        gratuity: {
          employeesCovered: "",
          workersCovered: "",
          deductedDeposited: "",
        },
        ESI: {
          employeesCovered: "",
          workersCovered: "",
          deductedDeposited: "",
        },
        others: {
          headerOthers: "",
          employeesCovered: "",
          workersCovered: "",
          deductedDeposited: "",
        },
      },
      previousFinancialYear: {
        pf: {
          employeesCovered: "",
          workersCovered: "",
          deductedDeposited: "Yes",
        },
        gratuity: {
          employeesCovered: "",
          workersCovered: "",
          deductedDeposited: "",
        },
        ESI: {
          employeesCovered: "",
          workersCovered: "",
          deductedDeposited: "",
        },
        others: {
          headerOthers: "",
          employeesCovered: "",
          workersCovered: "",
          deductedDeposited: "",
        },
      },
    },
    accessibilityUnderRPWD2016: {
      status: true,
      remark: "",
    },
    // 4
    rightsOfPersonsDisability2016: {
      status: true,
      webLink: "",
    },
    returnAndRetentionParentalLeave: {
      permanentEmployees: {
        male: {
          returnToWorkRate: "",
          retentionRate: "",
        },
        female: {
          returnToWorkRate: "",
          retentionRate: "",
        },
        total: {
          returnToWorkRate: "",
          retentionRate: "",
        },
      },
      permanentWorkers: {
        male: {
          returnToWorkRate: "",
          retentionRate: "",
        },
        female: {
          returnToWorkRate: "",
          retentionRate: "",
        },
        total: {
          returnToWorkRate: "",
          retentionRate: "",
        },
      },
    },
    grievanceRedressalMechanism: {
      permanentEmployees: {
        code: "",
        remark: "",
      },
      otherThanPermanentEmployees: {
        code: "",
        remark: "",
      },
      permanentWorkers: {
        code: "",
        remark: "",
      },
      otherThanPermanentWorkers: {
        code: "",
        remark: "",
      },
    },
    //7
    membershipInAssociationsOrUnions: {
      permanentEmployees: {
        currentFinancialYear: {
          totalMaleEmployees: "",
          totalFemaleEmployees: "",
          totalEmployeesCategory: "",
          NoofEmployeesCategory: "",
          NoOfMaleEmployeesCategory: "",
          NoOfFemaleEmployeesCategory: "",
          totalMaleEmployeesPercentage: "",
          totalfemaleEmployeesPercentage: "",
        },
        previousFinancialYear: {
          totalMaleEmployees: "",
          totalFemaleEmployees: "",
          totalEmployeesCategory: "",
          NoofEmployeesCategory: "",
          NoOfMaleEmployeesCategory: "",
          NoOfFemaleEmployeesCategory: "",
          totalMaleEmployeesPercentage: "",
          totalfemaleEmployeesPercentage: "",
        },
      },
      permanentWorkers: {
        currentFinancialYear: {
          totalMaleEmployees: "",
          totalFemaleEmployees: "",
          totalEmployeesCategory: "",
          NoofEmployeesCategory: "",
          NoOfMaleEmployeesCategory: "",
          NoOfFemaleEmployeesCategory: "",
          totalMaleEmployeesPercentage: "",
          totalfemaleEmployeesPercentage: "",
        },
        previousFinancialYear: {
          totalMaleEmployees: "",
          totalFemaleEmployees: "",
          totalEmployeesCategory: "",
          NoofEmployeesCategory: "",
          NoOfMaleEmployeesCategory: "",
          NoOfFemaleEmployeesCategory: "",
          totalMaleEmployeesPercentage: "",
          totalfemaleEmployeesPercentage: "",
        },
      },
    },
    //8
    trainingDetails: {
      currentFinancialYear: {
        workerTrainingUpgradation: {
          totalMale: "",
          totalFemale: "",
          Total: "",
          HealthMalePercentage: "",
          HealthFemalePercentage: "",
          HealthMaleNumber: "",
          HealthFemaleNumber: "",
          HealthTotal: "",
          SkillMaleNumber: "",
          SkillFemaleNumber: "",
          SkillMalePercentage: "",
          SkillFemalePercentage: "",
          SkillTotal: "",
        },
        employeeTrainingUpgradation: {
          totalMale: "",
          totalFemale: "",
          Total: "",
          HealthMalePercentage: "",
          HealthFemalePercentage: "",
          HealthMaleNumber: "",
          HealthFemaleNumber: "",
          HealthTotal: "",
          SkillMaleNumber: "",
          SkillFemaleNumber: "",
          SkillMalePercentage: "",
          SkillFemalePercentage: "",
          SkillTotal: "",
        },
      },
      previousFinancialYear: {
        workerTrainingUpgradation: {
          totalMale: "",
          totalFemale: "",
          Total: "",
          HealthMalePercentage: "",
          HealthFemalePercentage: "",
          HealthMaleNumber: "",
          HealthFemaleNumber: "",
          HealthTotal: "",
          SkillMaleNumber: "",
          SkillFemaleNumber: "",
          SkillMalePercentage: "",
          SkillFemalePercentage: "",
          SkillTotal: "",
        },
        employeeTrainingUpgradation: {
          totalMale: "",
          totalFemale: "",
          Total: "",
          HealthMalePercentage: "",
          HealthFemalePercentage: "",
          HealthMaleNumber: "",
          HealthFemaleNumber: "",
          HealthTotal: "",
          SkillMaleNumber: "",
          SkillFemaleNumber: "",
          SkillMalePercentage: "",
          SkillFemalePercentage: "",
          SkillTotal: "",
        },
      },
    },
    //9
    performanceAndCareerReviews: {
      employee: {
        currentFinancialYear: {
          totalEmployee: {
            male: "",
            female: "",
            total: "",
          },
          employee: {
            male: "",
            female: "",
            total: "",
          },
          Percentage: {
            male: "",
            female: "",
            total: "",
          },
        },
        previousFinancialYear: {
          totalEmployee: {
            male: "",
            female: "",
            total: "",
          },
          employee: {
            male: "",
            female: "",
            total: "",
          },
          Percentage: {
            male: "",
            female: "",
            total: "",
          },
        },
      },
      workers: {
        currentFinancialYear: {
          totalEmployee: {
            male: "",
            female: "",
            total: "",
          },
          employee: {
            male: "",
            female: "",
            total: "",
          },
          Percentage: {
            male: "",
            female: "",
            total: "",
          },
        },
        previousFinancialYear: {
          totalEmployee: {
            male: "",
            female: "",
            total: "",
          },
          employee: {
            male: "",
            female: "",
            total: "",
          },
          Percentage: {
            male: "",
            female: "",
            total: "",
          },
        },
      },
    },
    //10
    healthAndSafetyManagement: {
      occupationalHealthAndSafety: {
        status: true,
        remark: "",
      },
      workRelatedHazardAssessment: {
        remark: "",
      },
      hazardReportingAndSelfRemovalProcess: {
        status: true,
      },
      nonOccupationalMedicalServicesAccess: {
        status: true,
      },
    },
    // 11
    safetyIncidents: {
      employees: {
        lostTimeInjuryFrequencyRate: {
          currentFinancialYear: "",
          previousFinancialYear: "",
        },
        totalRecordableInjuries: {
          currentFinancialYear: "",
          previousFinancialYear: "",
        },
        numberOfFatalities: {
          currentFinancialYear: "",
          previousFinancialYear: "",
        },
        highConsequenceInjuries: {
          currentFinancialYear: "",
          previousFinancialYear: "",
        },
      },
      workers: {
        lostTimeInjuryFrequencyRate: {
          currentFinancialYear: "",
          previousFinancialYear: "",
        },
        totalRecordableInjuries: {
          currentFinancialYear: "",
          previousFinancialYear: "",
        },
        numberOfFatalities: {
          currentFinancialYear: "",
          previousFinancialYear: "",
        },
        highConsequenceInjuries: {
          currentFinancialYear: "",
          previousFinancialYear: "",
        },
      },
    },
    //12
    safetyMeasures: "",
    // 13
    complaintsMadeByEmployeesAndWorkers: {
      currentFinancialYear: {
        workingCondition: { filled: "", pending: "", remark: "" },
        healthAndSafety: { filled: "", pending: "", remark: "" },
      },
      previousFinancialYear: {
        workingCondition: { filled: "", pending: "", remark: "" },
        healthAndSafety: { filled: "", pending: "", remark: "" },
      },
    },
    // 14
    assessmentYear: {
      healthAndSafetyPractice: "",
      workingCondition: "",
    },
    // 15
    healthAndSafetyPracticesWorking: "",
    wellBeingMeasuresAndWorkersDoc: [],
    retirementBenefitsDoc: [],
    accessibilityUnderRPWD2016Doc: [],
    rightsOfPersonsDisability2016Doc: [],
    returnAndRetentionParentalLeaveDoc: [],
    grievanceRedressalMechanismDoc: [],
    membershipInAssociationsOrUnionsDoc: [],
    trainingDetailsDoc: [],
    performanceAndCareerReviewsDoc: [],
    healthAndSafetyManagementDoc: [],
    safetyIncidentsDoc: [],
    ssafetyMeasuresDoc: [],
    complaintsMadeByEmployeesAndWorkersDoc: [],
    assessmentYearDoc: [],
    healthAndSafetyPracticesWorkingDoc: [],
  });
  const heading = [
    { title: "% of employees covered by" },
    { title: "Male (No.)", key: "male" },
    { title: "Male (%)", key: "malePercentage" },
    { title: "Female (No.)", key: "female" },
    { title: "Female (%)", key: "femalePercentage" },
  ];
  const headingWorker = [
    { title: "% of workers covered by" },
    { title: "Male (No.)", key: "male" },
    { title: "Male (%)", key: "malePercentage" },
    { title: "Female (No.)", key: "female" },
    { title: "Female (%)", key: "femalePercentage" },
  ];
  const headingNumber = [
    { title: "Category" },
    { title: "Filed during the year", key: "filled" },
    { title: "Pending resolution at the end of year", key: "pending" },
    { title: "Remarks", key: "remark", type: "text" },
  ];
  const headingPerformance = [
    { title: "Category" },
    {
      title: "Total No. of Employees",
      key: "performanceAndCareerReviews.employee.currentFinancialYear.totalEmployee",
    },
    {
      title: "No. of Employees",
      key: "performanceAndCareerReviews.employee.currentFinancialYear.employee",
    },
    {
      title: "% of Employees",
      key: "performanceAndCareerReviews.employee.currentFinancialYear.Percentage",
    },
  ];
  const headingPerformancepreviousFinancialYear = [
    { title: "Category" },
    {
      title: "Total No. of Employees",
      key: "performanceAndCareerReviews.employee.previousFinancialYear.totalEmployee",
    },
    {
      title: "No. of Employees",
      key: "performanceAndCareerReviews.employee.previousFinancialYear.employee",
    },
    {
      title: "% of Employees",
      key: "performanceAndCareerReviews.employee.previousFinancialYear.Percentage",
    },
  ];
  const headingPerformanceWorkers = [
    { title: "Category" },
    {
      title: "Total No. of Workers",
      key: "performanceAndCareerReviews.workers.currentFinancialYear.totalEmployee",
    },
    {
      title: "No. of Workers",
      key: "performanceAndCareerReviews.workers.currentFinancialYear.employee",
    },
    {
      title: "% of Workers",
      key: "performanceAndCareerReviews.workers.currentFinancialYear.Percentage",
    },
  ];
  const headingPerformanceWorkerspreviousFinancialYear = [
    { title: "Category" },
    {
      title: "Total No. of Workers",
      key: "performanceAndCareerReviews.workers.previousFinancialYear.totalEmployee",
    },
    {
      title: "No. of Workers",
      key: "performanceAndCareerReviews.workers.previousFinancialYear.employee",
    },
    {
      title: "% of Workers",
      key: "performanceAndCareerReviews.workers.previousFinancialYear.Percentage",
    },
  ];
  useEffect(() => {}, [rowindex]);

  const headingAssessment = [
    { title: "Category" },
    {
      title:
        "% of your plants and offices that were assessed (by entity or statutory authorities or third parties)",
      type: "percentage",
    },
  ];
  const safetyRelated = [
    { title: "Safety Incident/Number" },
    { title: "Current Financial Year", key: "currentFinancialYear" },
    { title: "Pervious Financial Year", key: "previousFinancialYear" },
  ];
  const headingretirementBenefits = [
    { title: "Benefits " },
    {
      title: "No. of employees covered as a % of total employees ",
      key: "employeesCovered",
      type: "percentage",
    },
    {
      title: "No. of workers covered as a % of total workers",
      key: "workersCovered",
      type: "percentage",
    },
    {
      title: "Deducted and deposited with the authority (Yes / No / NA)",
      type: "boolean",
      key: "deductedDeposited",
    },
  ];
  const headingreturnAndRetentionParentalLeave = [
    { title: "Gender" },
    { title: "Return to work rate", key: "returnToWorkRate" },
    { title: "Retention rate", key: "retentionRate" }, // Changed this to avoid duplicate titles
  ];
  const headingMechanism = [
    { title: "" },
    { title: "NIC Code", key: "code", type: "boolean" },
    {
      title: "(If Yes, then give details of the mechanism in brief)",
      key: "remark",
    },
  ];
  const headingEmployeeWorker = [
    { title: "" },
    { title: "Category", key: "code" },
    {
      title: "Total employee/workers in respective category",
      key: "remark",
    },
    {
      title:
        "No. of employees / workers in respective category, who are part of association(s) or Union",
      key: "remark",
    },
    {
      title: "%",
      key: "remark",
    },
  ];
  const headingEmployeesWorker = [
    { title: "" },
    { title: "Category", key: "code" },
    {
      title: "Total",
      key: "remark",
    },
    {
      title: "On Health and safety measures",
      subtitle: [{ title: "Number" }, { title: "Percentage" }],
      key: "remark",
    },
    {
      title: "On skill upgradation",
      subtitle: [{ title: "Number" }, { title: "Percentage" }],
      key: "remark",
    },
  ];

  const fetchData = async () => {
    try {
      const res = await get(
        `/brsr/get?subType=principle3&type=SectionC&id=${id}`,
      );
      const res1 =
        res?.data?.data?.BRSRSectionC?.principle3?.essentialIndicators;
      if (
        res?.data?.data?.year
          ? res?.data?.data?.year < currentYear - 1
          : false || !brsrReview
      )
        setDisabled(true);
      const showZeroOrEmpty = (val) => (val === 0 ? 0 : val || "");

      setFormData((prev) => ({
        type: "SectionC",
        wellBeingMeasures: {
          maleEmployees: {
            permanentEmployees:
              showZeroOrEmpty(
                res1?.wellBeingMeasures?.maleEmployees?.permanentEmployees,
              ) ?? "",
            otherEmployees:
              showZeroOrEmpty(
                res1?.wellBeingMeasures?.maleEmployees?.otherEmployees,
              ) ?? "",
          },
          femaleEmployees: {
            permanentEmployees:
              showZeroOrEmpty(
                res1?.wellBeingMeasures?.femaleEmployees?.permanentEmployees,
              ) ?? "",
            otherEmployees:
              showZeroOrEmpty(
                res1?.wellBeingMeasures?.femaleEmployees?.otherEmployees,
              ) ?? "",
          },
          permanentEmployees: {
            healthInsurance: {
              male:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.permanentEmployees?.healthInsurance
                    ?.male,
                ) ?? "",
              malePercentage:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.permanentEmployees?.healthInsurance
                    ?.malePercentage,
                ) ?? "",
              female:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.permanentEmployees?.healthInsurance
                    ?.female,
                ) ?? "",
              femalePercentage:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.permanentEmployees?.healthInsurance
                    ?.femalePercentage,
                ) ?? "",
            },
            accidentInsurance: {
              male:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.permanentEmployees?.accidentInsurance
                    ?.male,
                ) ?? "",
              malePercentage:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.permanentEmployees?.accidentInsurance
                    ?.malePercentage,
                ) ?? "",
              female:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.permanentEmployees?.accidentInsurance
                    ?.female,
                ) ?? "",
              femalePercentage:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.permanentEmployees?.accidentInsurance
                    ?.femalePercentage,
                ) ?? "",
            },
            maternityBenefits: {
              male:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.permanentEmployees?.healthInsurance
                    ?.male,
                ) ?? "",
              malePercentage:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.permanentEmployees?.healthInsurance
                    ?.malePercentage,
                ) ?? "",
              female:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.permanentEmployees?.healthInsurance
                    ?.female,
                ) ?? "",
              femalePercentage:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.permanentEmployees?.healthInsurance
                    ?.femalePercentage,
                ) ?? "",
            },
            paternityBenefits: {
              male:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.permanentEmployees?.paternityBenefits
                    ?.male,
                ) ?? "",
              malePercentage:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.permanentEmployees?.paternityBenefits
                    ?.malePercentage,
                ) ?? "",
              female:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.permanentEmployees?.paternityBenefits
                    ?.female,
                ) ?? "",
              femalePercentage:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.permanentEmployees?.paternityBenefits
                    ?.femalePercentage,
                ) ?? "",
            },
            dayCareFacilities: {
              male:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.permanentEmployees?.dayCareFacilities
                    ?.male,
                ) ?? "",
              malePercentage:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.permanentEmployees?.dayCareFacilities
                    ?.malePercentage,
                ) ?? "",
              female:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.permanentEmployees?.dayCareFacilities
                    ?.female,
                ) ?? "",
              femalePercentage:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.permanentEmployees?.dayCareFacilities
                    ?.femalePercentage,
                ) ?? "",
            },
            Total: {
              male:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.permanentEmployees?.Total?.male,
                ) ?? "",
              malePercentage:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.permanentEmployees?.Total
                    ?.malePercentage,
                ) ?? "",
              female:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.permanentEmployees?.Total?.female,
                ) ?? "",
              femalePercentage:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.permanentEmployees?.Total
                    ?.femalePercentage,
                ) ?? "",
            },
          },
          otherEmployees: {
            healthInsurance: {
              male:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.otherEmployees?.healthInsurance
                    ?.male,
                ) ?? "",
              malePercentage:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.otherEmployees?.healthInsurance
                    ?.malePercentage,
                ) ?? "",
              female:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.otherEmployees?.healthInsurance
                    ?.female,
                ) ?? "",
              femalePercentage:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.otherEmployees?.healthInsurance
                    ?.femalePercentage,
                ) ?? "",
            },
            accidentInsurance: {
              male:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.otherEmployees?.accidentInsurance
                    ?.male,
                ) ?? "",
              malePercentage:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.otherEmployees?.accidentInsurance
                    ?.malePercentage,
                ) ?? "",
              female:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.otherEmployees?.accidentInsurance
                    ?.female,
                ) ?? "",
              femalePercentage:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.otherEmployees?.accidentInsurance
                    ?.femalePercentage,
                ) ?? "",
            },
            maternityBenefits: {
              male:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.otherEmployees?.maternityBenefits
                    ?.male,
                ) ?? "",
              malePercentage:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.otherEmployees?.maternityBenefits
                    ?.malePercentage,
                ) ?? "",
              female:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.otherEmployees?.maternityBenefits
                    ?.female,
                ) ?? "",
              femalePercentage:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.otherEmployees?.maternityBenefits
                    ?.femalePercentage,
                ) ?? "",
            },
            paternityBenefits: {
              male:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.otherEmployees?.paternityBenefits
                    ?.male,
                ) ?? "",
              malePercentage:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.otherEmployees?.paternityBenefits
                    ?.malePercentage,
                ) ?? "",
              female:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.otherEmployees?.paternityBenefits
                    ?.female,
                ) ?? "",
              femalePercentage:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.otherEmployees?.paternityBenefits
                    ?.femalePercentage,
                ) ?? "",
            },
            dayCareFacilities: {
              male:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.otherEmployees?.dayCareFacilities
                    ?.male,
                ) ?? "",
              malePercentage:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.otherEmployees?.dayCareFacilities
                    ?.malePercentage,
                ) ?? "",
              female:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.otherEmployees?.dayCareFacilities
                    ?.female,
                ) ?? "",
              femalePercentage:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.otherEmployees?.dayCareFacilities
                    ?.femalePercentage,
                ) ?? "",
            },
            Total: {
              male:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.otherEmployees?.Total?.male,
                ) ?? "",
              malePercentage:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.otherEmployees?.Total
                    ?.malePercentage,
                ) ?? "",
              female:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.otherEmployees?.Total?.female,
                ) ?? "",
              femalePercentage:
                showZeroOrEmpty(
                  res1?.wellBeingMeasures?.otherEmployees?.Total
                    ?.femalePercentage,
                ) ?? "",
            },
          },
        },
        wellBeingMeasuresCurrent:
          showZeroOrEmpty(res1?.wellBeingMeasuresCurrent) || "",
        wellBeingMeasuresPrevious:
          showZeroOrEmpty(res1?.wellBeingMeasuresPrevious) || "",
        wellBeingWorkers: {
          ...prev?.wellBeingWorkers,
          ...res1?.wellBeingWorkers,
        },

        retirementBenefits: {
          currentFinancialYear: {
            pf: {
              employeesCovered:
                showZeroOrEmpty(
                  res1?.retirementBenefits?.currentFinancialYear?.pf
                    ?.employeesCovered,
                ) ?? "",
              workersCovered:
                showZeroOrEmpty(
                  res1?.retirementBenefits?.currentFinancialYear?.pf
                    ?.workersCovered,
                ) ?? "",
              deductedDeposited:
                res1?.retirementBenefits?.currentFinancialYear?.pf
                  ?.deductedDeposited ?? "",
            },
            gratuity: {
              employeesCovered:
                showZeroOrEmpty(
                  res1?.retirementBenefits?.currentFinancialYear?.gratuity
                    ?.employeesCovered,
                ) ?? "",
              workersCovered:
                showZeroOrEmpty(
                  res1?.retirementBenefits?.currentFinancialYear?.gratuity
                    ?.workersCovered,
                ) ?? "",
              deductedDeposited:
                res1?.retirementBenefits?.currentFinancialYear?.gratuity
                  ?.deductedDeposited ?? "",
            },
            ESI: {
              employeesCovered:
                showZeroOrEmpty(
                  res1?.retirementBenefits?.currentFinancialYear?.ESI
                    ?.employeesCovered,
                ) ?? "",
              workersCovered:
                showZeroOrEmpty(
                  res1?.retirementBenefits?.currentFinancialYear?.ESI
                    ?.workersCovered,
                ) ?? "",
              deductedDeposited:
                res1?.retirementBenefits?.currentFinancialYear?.ESI
                  ?.deductedDeposited ?? "",
            },
            others: {
              headerOthers:
                showZeroOrEmpty(
                  res1?.retirementBenefits?.currentFinancialYear?.others
                    ?.headerOthers,
                ) ?? "",
              employeesCovered:
                showZeroOrEmpty(
                  res1?.retirementBenefits?.currentFinancialYear?.others
                    ?.employeesCovered,
                ) ?? "",
              workersCovered:
                showZeroOrEmpty(
                  res1?.retirementBenefits?.currentFinancialYear?.others
                    ?.workersCovered,
                ) ?? "",
              deductedDeposited:
                res1?.retirementBenefits?.currentFinancialYear?.others
                  ?.deductedDeposited ?? "",
            },
          },
          previousFinancialYear: {
            pf: {
              employeesCovered:
                showZeroOrEmpty(
                  res1?.retirementBenefits?.previousFinancialYear?.pf
                    ?.employeesCovered,
                ) ?? "",
              workersCovered:
                showZeroOrEmpty(
                  res1?.retirementBenefits?.previousFinancialYear?.pf
                    ?.workersCovered,
                ) ?? "",
              deductedDeposited:
                res1?.retirementBenefits?.previousFinancialYear?.pf
                  ?.deductedDeposited ?? "",
            },
            gratuity: {
              employeesCovered:
                showZeroOrEmpty(
                  res1?.retirementBenefits?.previousFinancialYear?.gratuity
                    ?.employeesCovered,
                ) ?? "",
              workersCovered:
                showZeroOrEmpty(
                  res1?.retirementBenefits?.previousFinancialYear?.gratuity
                    ?.workersCovered,
                ) ?? "",
              deductedDeposited:
                res1?.retirementBenefits?.previousFinancialYear?.gratuity
                  ?.deductedDeposited ?? "",
            },
            ESI: {
              employeesCovered:
                showZeroOrEmpty(
                  res1?.retirementBenefits?.previousFinancialYear?.ESI
                    ?.employeesCovered,
                ) ?? "",
              workersCovered:
                showZeroOrEmpty(
                  res1?.retirementBenefits?.previousFinancialYear?.ESI
                    ?.workersCovered,
                ) ?? "",
              deductedDeposited:
                res1?.retirementBenefits?.previousFinancialYear?.ESI
                  ?.deductedDeposited ?? "",
            },
            others: {
              headerOthers:
                showZeroOrEmpty(
                  res1?.retirementBenefits?.previousFinancialYear?.others
                    ?.headerOthers,
                ) ?? "",
              employeesCovered:
                showZeroOrEmpty(
                  res1?.retirementBenefits?.previousFinancialYear?.others
                    ?.employeesCovered,
                ) ?? "",
              workersCovered:
                showZeroOrEmpty(
                  res1?.retirementBenefits?.previousFinancialYear?.others
                    ?.workersCovered,
                ) ?? "",
              deductedDeposited:
                showZeroOrEmpty(
                  res1?.retirementBenefits?.previousFinancialYear?.others
                    ?.deductedDeposited,
                ) ?? "",
            },
          },
        },
        accessibilityUnderRPWD2016: {
          status: res1?.accessibilityUnderRPWD2016?.status ?? true,
          remark: res1?.accessibilityUnderRPWD2016?.remark ?? "",
        },
        // 4
        rightsOfPersonsDisability2016: {
          status: res1?.rightsOfPersonsDisability2016?.status
            ? res1?.rightsOfPersonsDisability2016?.status
            : ("" ?? true),
          webLink: res1?.rightsOfPersonsDisability2016?.webLink ?? "",
        },
        returnAndRetentionParentalLeave: {
          permanentEmployees: {
            male: {
              returnToWorkRate:
                showZeroOrEmpty(
                  res1?.returnAndRetentionParentalLeave?.permanentEmployees
                    ?.male?.returnToWorkRate,
                ) ?? "",
              retentionRate:
                showZeroOrEmpty(
                  res1?.returnAndRetentionParentalLeave?.permanentEmployees
                    ?.male?.retentionRate,
                ) ?? "",
            },
            female: {
              returnToWorkRate:
                showZeroOrEmpty(
                  res1?.returnAndRetentionParentalLeave?.permanentEmployees
                    ?.female?.returnToWorkRate,
                ) ?? "",
              retentionRate:
                showZeroOrEmpty(
                  res1?.returnAndRetentionParentalLeave?.permanentEmployees
                    ?.female?.retentionRate,
                ) ?? "",
            },
            total: {
              returnToWorkRate:
                showZeroOrEmpty(
                  res1?.returnAndRetentionParentalLeave?.permanentEmployees
                    ?.total?.returnToWorkRate,
                ) ?? "",
              retentionRate:
                showZeroOrEmpty(
                  res1?.returnAndRetentionParentalLeave?.permanentEmployees
                    ?.total?.retentionRate,
                ) ?? "",
            },
          },
          permanentWorkers: {
            male: {
              returnToWorkRate:
                showZeroOrEmpty(
                  res1?.returnAndRetentionParentalLeave?.permanentWorkers?.male
                    ?.returnToWorkRate,
                ) ?? "",
              retentionRate:
                showZeroOrEmpty(
                  res1?.returnAndRetentionParentalLeave?.permanentWorkers?.male
                    ?.retentionRate,
                ) ?? "",
            },
            female: {
              returnToWorkRate:
                showZeroOrEmpty(
                  res1?.returnAndRetentionParentalLeave?.permanentWorkers
                    ?.female?.returnToWorkRate,
                ) ?? "",
              retentionRate:
                showZeroOrEmpty(
                  res1?.returnAndRetentionParentalLeave?.permanentWorkers
                    ?.female?.retentionRate,
                ) ?? "",
            },
            total: {
              returnToWorkRate:
                showZeroOrEmpty(
                  res1?.returnAndRetentionParentalLeave?.permanentWorkers?.total
                    ?.returnToWorkRate,
                ) ?? "",
              retentionRate:
                showZeroOrEmpty(
                  res1?.returnAndRetentionParentalLeave?.permanentWorkers?.total
                    ?.retentionRate,
                ) ?? "",
            },
          },
        },
        grievanceRedressalMechanism: {
          permanentEmployees: {
            code:
              res1?.grievanceRedressalMechanism?.permanentEmployees?.code ??
              "Yes",
            remark:
              res1?.grievanceRedressalMechanism?.permanentEmployees?.remark ??
              "",
          },
          otherThanPermanentEmployees: {
            code:
              res1?.grievanceRedressalMechanism?.otherThanPermanentEmployees
                ?.code ?? "Yes",
            remark:
              res1?.grievanceRedressalMechanism?.otherThanPermanentEmployees
                ?.remark ?? "",
          },
          permanentWorkers: {
            code:
              res1?.grievanceRedressalMechanism?.permanentWorkers?.code ??
              "Yes",
            remark:
              res1?.grievanceRedressalMechanism?.permanentWorkers?.remark ?? "",
          },
          otherThanPermanentWorkers: {
            code:
              res1?.grievanceRedressalMechanism?.otherThanPermanentWorkers
                ?.code ?? "Yes",
            remark:
              res1?.grievanceRedressalMechanism?.otherThanPermanentWorkers
                ?.remark ?? "",
          },
        },
        //7
        membershipInAssociationsOrUnions: {
          permanentEmployees: {
            currentFinancialYear: {
              totalMaleEmployees:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentEmployees
                    ?.currentFinancialYear?.totalMaleEmployees,
                ) ?? "",
              totalFemaleEmployees:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentEmployees
                    ?.currentFinancialYear?.totalFemaleEmployees,
                ) ?? "",
              totalEmployeesCategory:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentEmployees
                    ?.currentFinancialYear?.totalEmployeesCategory,
                ) ?? "",
              NoofEmployeesCategory:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentEmployees
                    ?.currentFinancialYear?.NoofEmployeesCategory,
                ) ?? "",
              NoOfMaleEmployeesCategory:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentEmployees
                    ?.currentFinancialYear?.NoOfMaleEmployeesCategory,
                ) ?? "",
              NoOfFemaleEmployeesCategory:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentEmployees
                    ?.currentFinancialYear?.NoOfFemaleEmployeesCategory,
                ) ?? "",
              totalMaleEmployeesPercentage:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentEmployees
                    ?.currentFinancialYear?.totalMaleEmployeesPercentage,
                ) ?? "",
              totalfemaleEmployeesPercentage:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentEmployees
                    ?.currentFinancialYear?.totalfemaleEmployeesPercentage,
                ) ?? "",
            },
            previousFinancialYear: {
              totalMaleEmployees:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentEmployees
                    ?.previousFinancialYear?.totalMaleEmployees,
                ) ?? "",
              totalFemaleEmployees:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentEmployees
                    ?.previousFinancialYear?.totalFemaleEmployees,
                ) ?? "",
              totalEmployeesCategory:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentEmployees
                    ?.previousFinancialYear?.totalEmployeesCategory,
                ) ?? "",
              NoofEmployeesCategory:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentEmployees
                    ?.previousFinancialYear?.NoofEmployeesCategory,
                ) ?? "",
              NoOfMaleEmployeesCategory:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentEmployees
                    ?.previousFinancialYear?.NoOfMaleEmployeesCategory,
                ) ?? "",
              NoOfFemaleEmployeesCategory:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentEmployees
                    ?.previousFinancialYear?.NoOfFemaleEmployeesCategory,
                ) ?? "",
              totalMaleEmployeesPercentage:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentEmployees
                    ?.previousFinancialYear?.totalMaleEmployeesPercentage,
                ) ?? "",
              totalfemaleEmployeesPercentage:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentEmployees
                    ?.previousFinancialYear?.totalfemaleEmployeesPercentage,
                ) ?? "",
            },
          },
          permanentWorkers: {
            currentFinancialYear: {
              totalMaleEmployees:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentWorkers
                    ?.currentFinancialYear?.totalMaleEmployees,
                ) ?? "",
              totalFemaleEmployees:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentWorkers
                    ?.currentFinancialYear?.totalFemaleEmployees,
                ) ?? "",
              totalEmployeesCategory:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentWorkers
                    ?.currentFinancialYear?.totalEmployeesCategory,
                ) ?? "",
              NoofEmployeesCategory:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentWorkers
                    ?.currentFinancialYear?.NoofEmployeesCategory,
                ) ?? "",
              NoOfMaleEmployeesCategory:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentWorkers
                    ?.currentFinancialYear?.NoOfMaleEmployeesCategory,
                ) ?? "",
              NoOfFemaleEmployeesCategory:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentWorkers
                    ?.currentFinancialYear?.NoOfFemaleEmployeesCategory,
                ) ?? "",
              totalMaleEmployeesPercentage:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentWorkers
                    ?.currentFinancialYear?.totalMaleEmployeesPercentage,
                ) ?? "",
              totalfemaleEmployeesPercentage:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentWorkers
                    ?.currentFinancialYear?.totalfemaleEmployeesPercentage,
                ) ?? "",
            },
            previousFinancialYear: {
              totalMaleEmployees:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentWorkers
                    ?.previousFinancialYear?.totalMaleEmployees,
                ) ?? "",
              totalFemaleEmployees:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentWorkers
                    ?.previousFinancialYear?.totalFemaleEmployees,
                ) ?? "",
              totalEmployeesCategory:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentWorkers
                    ?.previousFinancialYear?.totalEmployeesCategory,
                ) ?? "",
              NoofEmployeesCategory:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentWorkers
                    ?.previousFinancialYear?.NoofEmployeesCategory,
                ) ?? "",
              NoOfMaleEmployeesCategory:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentWorkers
                    ?.previousFinancialYear?.NoOfMaleEmployeesCategory,
                ) ?? "",
              NoOfFemaleEmployeesCategory:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentWorkers
                    ?.previousFinancialYear?.NoOfFemaleEmployeesCategory,
                ) ?? "",
              totalMaleEmployeesPercentage:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentWorkers
                    ?.previousFinancialYear?.totalMaleEmployeesPercentage,
                ) ?? "",
              totalfemaleEmployeesPercentage:
                showZeroOrEmpty(
                  res1?.membershipInAssociationsOrUnions?.permanentWorkers
                    ?.previousFinancialYear?.totalfemaleEmployeesPercentage,
                ) ?? "",
            },
          },
        },
        //8
        trainingDetails: {
          currentFinancialYear: {
            workerTrainingUpgradation: {
              totalMale:
                showZeroOrEmpty(
                  res1?.trainingDetails?.currentFinancialYear
                    ?.workerTrainingUpgradation?.totalMale,
                ) ?? "",
              totalFemale:
                showZeroOrEmpty(
                  res1?.trainingDetails?.currentFinancialYear
                    ?.workerTrainingUpgradation?.totalFemale,
                ) ?? "",
              Total:
                showZeroOrEmpty(
                  res1?.trainingDetails?.currentFinancialYear
                    ?.workerTrainingUpgradation?.Total,
                ) ?? "",
              HealthMalePercentage:
                showZeroOrEmpty(
                  res1?.trainingDetails?.currentFinancialYear
                    ?.workerTrainingUpgradation?.HealthMalePercentage,
                ) ?? "",
              HealthFemalePercentage:
                showZeroOrEmpty(
                  res1?.trainingDetails?.currentFinancialYear
                    ?.workerTrainingUpgradation?.HealthFemalePercentage,
                ) ?? "",
              HealthMaleNumber:
                showZeroOrEmpty(
                  res1?.trainingDetails?.currentFinancialYear
                    ?.workerTrainingUpgradation?.HealthMaleNumber,
                ) ?? "",
              HealthFemaleNumber:
                showZeroOrEmpty(
                  res1?.trainingDetails?.currentFinancialYear
                    ?.workerTrainingUpgradation?.HealthFemaleNumber,
                ) ?? "",
              HealthTotal:
                showZeroOrEmpty(
                  res1?.trainingDetails?.currentFinancialYear
                    ?.workerTrainingUpgradation?.HealthTotal,
                ) ?? "",
              SkillMaleNumber:
                showZeroOrEmpty(
                  res1?.trainingDetails?.currentFinancialYear
                    ?.workerTrainingUpgradation?.SkillMaleNumber,
                ) ?? "",
              SkillFemaleNumber:
                showZeroOrEmpty(
                  res1?.trainingDetails?.currentFinancialYear
                    ?.workerTrainingUpgradation?.SkillFemaleNumber,
                ) ?? "",
              SkillMalePercentage:
                showZeroOrEmpty(
                  res1?.trainingDetails?.currentFinancialYear
                    ?.workerTrainingUpgradation?.SkillMalePercentage,
                ) ?? "",
              SkillFemalePercentage:
                showZeroOrEmpty(
                  res1?.trainingDetails?.currentFinancialYear
                    ?.workerTrainingUpgradation?.SkillFemalePercentage,
                ) ?? "",
              SkillTotal:
                showZeroOrEmpty(
                  res1?.trainingDetails?.currentFinancialYear
                    ?.workerTrainingUpgradation?.SkillTotal,
                ) ?? "",
            },
            employeeTrainingUpgradation: {
              totalMale:
                showZeroOrEmpty(
                  res1?.trainingDetails?.currentFinancialYear
                    ?.employeeTrainingUpgradation?.totalMale,
                ) ?? "",
              totalFemale:
                showZeroOrEmpty(
                  res1?.trainingDetails?.currentFinancialYear
                    ?.employeeTrainingUpgradation?.totalFemale,
                ) ?? "",
              Total:
                showZeroOrEmpty(
                  res1?.trainingDetails?.currentFinancialYear
                    ?.employeeTrainingUpgradation?.Total,
                ) ?? "",
              HealthMalePercentage:
                showZeroOrEmpty(
                  res1?.trainingDetails?.currentFinancialYear
                    ?.employeeTrainingUpgradation?.HealthMalePercentage,
                ) ?? "",
              HealthFemalePercentage:
                showZeroOrEmpty(
                  res1?.trainingDetails?.currentFinancialYear
                    ?.employeeTrainingUpgradation?.HealthFemalePercentage,
                ) ?? "",
              HealthMaleNumber:
                showZeroOrEmpty(
                  res1?.trainingDetails?.currentFinancialYear
                    ?.employeeTrainingUpgradation?.HealthMaleNumber,
                ) ?? "",
              HealthFemaleNumber:
                showZeroOrEmpty(
                  res1?.trainingDetails?.currentFinancialYear
                    ?.employeeTrainingUpgradation?.HealthFemaleNumber,
                ) ?? "",
              HealthTotal:
                showZeroOrEmpty(
                  res1?.trainingDetails?.currentFinancialYear
                    ?.employeeTrainingUpgradation?.HealthTotal,
                ) ?? "",
              SkillMaleNumber:
                showZeroOrEmpty(
                  res1?.trainingDetails?.currentFinancialYear
                    ?.employeeTrainingUpgradation?.SkillMaleNumber,
                ) ?? "",
              SkillFemaleNumber:
                showZeroOrEmpty(
                  res1?.trainingDetails?.currentFinancialYear
                    ?.employeeTrainingUpgradation?.SkillFemaleNumber,
                ) ?? "",
              SkillMalePercentage:
                showZeroOrEmpty(
                  res1?.trainingDetails?.currentFinancialYear
                    ?.employeeTrainingUpgradation?.SkillMalePercentage,
                ) ?? "",
              SkillFemalePercentage:
                showZeroOrEmpty(
                  res1?.trainingDetails?.currentFinancialYear
                    ?.employeeTrainingUpgradation?.SkillFemalePercentage,
                ) ?? "",
              SkillTotal:
                showZeroOrEmpty(
                  res1?.trainingDetails?.currentFinancialYear
                    ?.employeeTrainingUpgradation?.SkillTotal,
                ) ?? "",
            },
          },
          previousFinancialYear: {
            workerTrainingUpgradation: {
              totalMale:
                showZeroOrEmpty(
                  res1?.trainingDetails?.previousFinancialYear
                    ?.workerTrainingUpgradation?.totalMale,
                ) ?? "",
              totalFemale:
                showZeroOrEmpty(
                  res1?.trainingDetails?.previousFinancialYear
                    ?.workerTrainingUpgradation?.totalFemale,
                ) ?? "",
              Total:
                showZeroOrEmpty(
                  res1?.trainingDetails?.previousFinancialYear
                    ?.workerTrainingUpgradation?.Total,
                ) ?? "",
              HealthMalePercentage:
                showZeroOrEmpty(
                  res1?.trainingDetails?.previousFinancialYear
                    ?.workerTrainingUpgradation?.HealthMalePercentage,
                ) ?? "",
              HealthFemalePercentage:
                showZeroOrEmpty(
                  res1?.trainingDetails?.previousFinancialYear
                    ?.workerTrainingUpgradation?.HealthFemalePercentage,
                ) ?? "",
              HealthMaleNumber:
                showZeroOrEmpty(
                  res1?.trainingDetails?.previousFinancialYear
                    ?.workerTrainingUpgradation?.HealthMaleNumber,
                ) ?? "",
              HealthFemaleNumber:
                showZeroOrEmpty(
                  res1?.trainingDetails?.previousFinancialYear
                    ?.workerTrainingUpgradation?.HealthFemaleNumber,
                ) ?? "",
              HealthTotal:
                showZeroOrEmpty(
                  res1?.trainingDetails?.previousFinancialYear
                    ?.workerTrainingUpgradation?.HealthTotal,
                ) ?? "",
              SkillMaleNumber:
                showZeroOrEmpty(
                  res1?.trainingDetails?.previousFinancialYear
                    ?.workerTrainingUpgradation?.SkillMaleNumber,
                ) ?? "",
              SkillFemaleNumber:
                showZeroOrEmpty(
                  res1?.trainingDetails?.previousFinancialYear
                    ?.workerTrainingUpgradation?.SkillFemaleNumber,
                ) ?? "",
              SkillMalePercentage:
                showZeroOrEmpty(
                  res1?.trainingDetails?.previousFinancialYear
                    ?.workerTrainingUpgradation?.SkillMalePercentage,
                ) ?? "",
              SkillFemalePercentage:
                showZeroOrEmpty(
                  res1?.trainingDetails?.previousFinancialYear
                    ?.workerTrainingUpgradation?.SkillFemalePercentage,
                ) ?? "",
              SkillTotal:
                showZeroOrEmpty(
                  res1?.trainingDetails?.previousFinancialYear
                    ?.workerTrainingUpgradation?.SkillTotal,
                ) ?? "",
            },
            employeeTrainingUpgradation: {
              totalMale:
                showZeroOrEmpty(
                  res1?.trainingDetails?.previousFinancialYear
                    ?.employeeTrainingUpgradation?.totalMale,
                ) ?? "",
              totalFemale:
                showZeroOrEmpty(
                  res1?.trainingDetails?.previousFinancialYear
                    ?.employeeTrainingUpgradation?.totalFemale,
                ) ?? "",
              Total:
                showZeroOrEmpty(
                  res1?.trainingDetails?.previousFinancialYear
                    ?.employeeTrainingUpgradation?.Total,
                ) ?? "",
              HealthMalePercentage:
                showZeroOrEmpty(
                  res1?.trainingDetails?.previousFinancialYear
                    ?.employeeTrainingUpgradation?.HealthMalePercentage,
                ) ?? "",
              HealthFemalePercentage:
                showZeroOrEmpty(
                  res1?.trainingDetails?.previousFinancialYear
                    ?.employeeTrainingUpgradation?.HealthFemalePercentage,
                ) ?? "",
              HealthMaleNumber:
                showZeroOrEmpty(
                  res1?.trainingDetails?.previousFinancialYear
                    ?.employeeTrainingUpgradation?.HealthMaleNumber,
                ) ?? "",
              HealthFemaleNumber:
                showZeroOrEmpty(
                  res1?.trainingDetails?.previousFinancialYear
                    ?.employeeTrainingUpgradation?.HealthFemaleNumber,
                ) ?? "",
              HealthTotal:
                showZeroOrEmpty(
                  res1?.trainingDetails?.previousFinancialYear
                    ?.employeeTrainingUpgradation?.HealthTotal,
                ) ?? "",
              SkillMaleNumber:
                showZeroOrEmpty(
                  res1?.trainingDetails?.previousFinancialYear
                    ?.employeeTrainingUpgradation?.SkillMaleNumber,
                ) ?? "",
              SkillFemaleNumber:
                showZeroOrEmpty(
                  res1?.trainingDetails?.previousFinancialYear
                    ?.employeeTrainingUpgradation?.SkillFemaleNumber,
                ) ?? "",
              SkillMalePercentage:
                showZeroOrEmpty(
                  res1?.trainingDetails?.previousFinancialYear
                    ?.employeeTrainingUpgradation?.SkillMalePercentage,
                ) ?? "",
              SkillFemalePercentage:
                showZeroOrEmpty(
                  res1?.trainingDetails?.previousFinancialYear
                    ?.employeeTrainingUpgradation?.SkillFemalePercentage,
                ) ?? "",
              SkillTotal:
                showZeroOrEmpty(
                  res1?.trainingDetails?.previousFinancialYear
                    ?.employeeTrainingUpgradation?.SkillTotal,
                ) ?? "",
            },
          },
        },
        //9
        performanceAndCareerReviews: {
          employee: {
            currentFinancialYear: {
              totalEmployee: {
                male:
                  showZeroOrEmpty(
                    res1?.performanceAndCareerReviews?.employee
                      ?.currentFinancialYear?.totalEmployee?.male,
                  ) ?? "",
                female:
                  showZeroOrEmpty(
                    res1?.performanceAndCareerReviews?.employee
                      ?.currentFinancialYear?.totalEmployee?.female,
                  ) ?? "",
                total:
                  showZeroOrEmpty(
                    res1?.performanceAndCareerReviews?.employee
                      ?.currentFinancialYear?.totalEmployee?.total,
                  ) ?? "",
              },
              employee: {
                male:
                  showZeroOrEmpty(
                    res1?.performanceAndCareerReviews?.employee
                      ?.currentFinancialYear?.employee?.male,
                  ) ?? "",
                female:
                  showZeroOrEmpty(
                    res1?.performanceAndCareerReviews?.employee
                      ?.currentFinancialYear?.employee?.female,
                  ) ?? "",
                total:
                  showZeroOrEmpty(
                    res1?.performanceAndCareerReviews?.employee
                      ?.currentFinancialYear?.employee?.total,
                  ) ?? "",
              },
              Percentage: {
                male:
                  res1?.performanceAndCareerReviews?.employee
                    ?.currentFinancialYear?.Percentage?.male ?? "",
                female:
                  res1?.performanceAndCareerReviews?.employee
                    ?.currentFinancialYear?.Percentage?.female ?? "",
                total:
                  res1?.performanceAndCareerReviews?.employee
                    ?.currentFinancialYear?.Percentage?.total ?? "",
              },
            },
            previousFinancialYear: {
              totalEmployee: {
                male:
                  showZeroOrEmpty(
                    res1?.performanceAndCareerReviews?.employee
                      ?.previousFinancialYear?.totalEmployee?.male,
                  ) ?? "",
                female:
                  showZeroOrEmpty(
                    res1?.performanceAndCareerReviews?.employee
                      ?.previousFinancialYear?.totalEmployee?.female,
                  ) ?? "",
                total:
                  showZeroOrEmpty(
                    res1?.performanceAndCareerReviews?.employee
                      ?.previousFinancialYear?.totalEmployee?.total,
                  ) ?? "",
              },
              employee: {
                male:
                  showZeroOrEmpty(
                    res1?.performanceAndCareerReviews?.employee
                      ?.previousFinancialYear?.employee?.male,
                  ) ?? "",
                female:
                  showZeroOrEmpty(
                    res1?.performanceAndCareerReviews?.employee
                      ?.previousFinancialYear?.employee?.female,
                  ) ?? "",
                total:
                  showZeroOrEmpty(
                    res1?.performanceAndCareerReviews?.employee
                      ?.previousFinancialYear?.employee?.total,
                  ) ?? "",
              },
              Percentage: {
                male:
                  res1?.performanceAndCareerReviews?.employee
                    ?.previousFinancialYear?.Percentage?.male ?? "",
                female:
                  res1?.performanceAndCareerReviews?.employee
                    ?.previousFinancialYear?.Percentage?.female ?? "",
                total:
                  res1?.performanceAndCareerReviews?.employee
                    ?.previousFinancialYear?.Percentage?.total ?? "",
              },
            },
          },
          workers: {
            currentFinancialYear: {
              totalEmployee: {
                male:
                  showZeroOrEmpty(
                    res1?.performanceAndCareerReviews?.workers
                      ?.currentFinancialYear?.totalEmployee?.male,
                  ) ?? "",
                female:
                  showZeroOrEmpty(
                    res1?.performanceAndCareerReviews?.workers
                      ?.currentFinancialYear?.totalEmployee?.female,
                  ) ?? "",
                total:
                  showZeroOrEmpty(
                    res1?.performanceAndCareerReviews?.workers
                      ?.currentFinancialYear?.totalEmployee?.total,
                  ) ?? "",
              },
              employee: {
                male:
                  showZeroOrEmpty(
                    res1?.performanceAndCareerReviews?.workers
                      ?.currentFinancialYear?.employee?.male,
                  ) ?? "",
                female:
                  showZeroOrEmpty(
                    res1?.performanceAndCareerReviews?.workers
                      ?.currentFinancialYear?.employee?.female,
                  ) ?? "",
                total:
                  showZeroOrEmpty(
                    res1?.performanceAndCareerReviews?.workers
                      ?.currentFinancialYear?.employee?.total,
                  ) ?? "",
              },
              Percentage: {
                male:
                  res1?.performanceAndCareerReviews?.workers
                    ?.currentFinancialYear?.Percentage?.male ?? "",
                female:
                  res1?.performanceAndCareerReviews?.workers
                    ?.currentFinancialYear?.Percentage?.female ?? "",
                total:
                  res1?.performanceAndCareerReviews?.workers
                    ?.currentFinancialYear?.Percentage?.total ?? "",
              },
            },
            previousFinancialYear: {
              totalEmployee: {
                male:
                  showZeroOrEmpty(
                    res1?.performanceAndCareerReviews?.workers
                      ?.previousFinancialYear?.totalEmployee?.male,
                  ) ?? "",
                female:
                  showZeroOrEmpty(
                    res1?.performanceAndCareerReviews?.workers
                      ?.previousFinancialYear?.totalEmployee?.female,
                  ) ?? "",
                total:
                  showZeroOrEmpty(
                    res1?.performanceAndCareerReviews?.workers
                      ?.previousFinancialYear?.totalEmployee?.total,
                  ) ?? "",
              },
              employee: {
                male:
                  showZeroOrEmpty(
                    res1?.performanceAndCareerReviews?.workers
                      ?.previousFinancialYear?.employee?.male,
                  ) ?? "",
                female:
                  showZeroOrEmpty(
                    res1?.performanceAndCareerReviews?.workers
                      ?.previousFinancialYear?.employee?.female,
                  ) ?? "",
                total:
                  showZeroOrEmpty(
                    res1?.performanceAndCareerReviews?.workers
                      ?.previousFinancialYear?.employee?.total,
                  ) ?? "",
              },
              Percentage: {
                male:
                  res1?.performanceAndCareerReviews?.workers
                    ?.previousFinancialYear?.Percentage?.male ?? "",
                female:
                  res1?.performanceAndCareerReviews?.workers
                    ?.previousFinancialYear?.Percentage?.female ?? "",
                total:
                  res1?.performanceAndCareerReviews?.workers
                    ?.previousFinancialYear?.Percentage?.total ?? "",
              },
            },
          },
        },
        //10
        healthAndSafetyManagement: {
          occupationalHealthAndSafety: {
            status:
              res1?.healthAndSafetyManagement?.occupationalHealthAndSafety
                ?.status ?? true,
            remark:
              res1?.healthAndSafetyManagement?.occupationalHealthAndSafety
                ?.remark ?? "",
          },
          workRelatedHazardAssessment: {
            remark:
              res1?.healthAndSafetyManagement?.workRelatedHazardAssessment
                ?.remark ?? "",
          },
          hazardReportingAndSelfRemovalProcess: {
            status:
              res1?.healthAndSafetyManagement
                ?.hazardReportingAndSelfRemovalProcess?.status ?? true,
          },
          nonOccupationalMedicalServicesAccess: {
            status:
              res1?.healthAndSafetyManagement
                ?.nonOccupationalMedicalServicesAccess?.status ?? true,
          },
        },
        // 11
        safetyIncidents: {
          employees: {
            lostTimeInjuryFrequencyRate: {
              currentFinancialYear:
                showZeroOrEmpty(
                  res1?.safetyIncidents?.employees?.lostTimeInjuryFrequencyRate
                    ?.currentFinancialYear,
                ) ?? "",
              previousFinancialYear:
                showZeroOrEmpty(
                  res1?.safetyIncidents?.employees?.lostTimeInjuryFrequencyRate
                    ?.previousFinancialYear,
                ) ?? "",
            },
            totalRecordableInjuries: {
              currentFinancialYear:
                showZeroOrEmpty(
                  res1?.safetyIncidents?.employees?.totalRecordableInjuries
                    ?.currentFinancialYear,
                ) ?? "",
              previousFinancialYear:
                showZeroOrEmpty(
                  res1?.safetyIncidents?.employees?.totalRecordableInjuries
                    ?.previousFinancialYear,
                ) ?? "",
            },
            numberOfFatalities: {
              currentFinancialYear:
                showZeroOrEmpty(
                  res1?.safetyIncidents?.employees?.numberOfFatalities
                    ?.currentFinancialYear,
                ) ?? "",
              previousFinancialYear:
                showZeroOrEmpty(
                  res1?.safetyIncidents?.employees?.numberOfFatalities
                    ?.previousFinancialYear,
                ) ?? "",
            },
            highConsequenceInjuries: {
              currentFinancialYear:
                showZeroOrEmpty(
                  res1?.safetyIncidents?.employees?.highConsequenceInjuries
                    ?.currentFinancialYear,
                ) ?? "",
              previousFinancialYear:
                showZeroOrEmpty(
                  res1?.safetyIncidents?.employees?.highConsequenceInjuries
                    ?.previousFinancialYear,
                ) ?? "",
            },
          },
          workers: {
            lostTimeInjuryFrequencyRate: {
              currentFinancialYear:
                showZeroOrEmpty(
                  res1?.safetyIncidents?.workers?.lostTimeInjuryFrequencyRate
                    ?.currentFinancialYear,
                ) ?? "",
              previousFinancialYear:
                showZeroOrEmpty(
                  res1?.safetyIncidents?.workers?.lostTimeInjuryFrequencyRate
                    ?.previousFinancialYear,
                ) ?? "",
            },
            totalRecordableInjuries: {
              currentFinancialYear:
                showZeroOrEmpty(
                  res1?.safetyIncidents?.workers?.totalRecordableInjuries
                    ?.currentFinancialYear,
                ) ?? "",
              previousFinancialYear:
                showZeroOrEmpty(
                  res1?.safetyIncidents?.workers?.totalRecordableInjuries
                    ?.previousFinancialYear,
                ) ?? "",
            },
            numberOfFatalities: {
              currentFinancialYear:
                showZeroOrEmpty(
                  res1?.safetyIncidents?.workers?.numberOfFatalities
                    ?.currentFinancialYear,
                ) ?? "",
              previousFinancialYear:
                showZeroOrEmpty(
                  res1?.safetyIncidents?.workers?.numberOfFatalities
                    ?.previousFinancialYear,
                ) ?? "",
            },
            highConsequenceInjuries: {
              currentFinancialYear:
                showZeroOrEmpty(
                  res1?.safetyIncidents?.workers?.highConsequenceInjuries
                    ?.currentFinancialYear,
                ) ?? "",
              previousFinancialYear:
                showZeroOrEmpty(
                  res1?.safetyIncidents?.workers?.highConsequenceInjuries
                    ?.previousFinancialYear,
                ) ?? "",
            },
          },
        },
        //12
        safetyMeasures: res1?.safetyMeasures ?? "",
        // 13
        complaintsMadeByEmployeesAndWorkers: {
          currentFinancialYear: {
            workingCondition: {
              filled:
                showZeroOrEmpty(
                  res1?.complaintsMadeByEmployeesAndWorkers
                    ?.currentFinancialYear?.workingCondition?.filled,
                ) ?? "",
              pending:
                showZeroOrEmpty(
                  res1?.complaintsMadeByEmployeesAndWorkers
                    ?.currentFinancialYear?.workingCondition?.pending,
                ) ?? "",
              remark:
                res1?.complaintsMadeByEmployeesAndWorkers?.currentFinancialYear
                  ?.workingCondition?.remark ?? "",
            },
            healthAndSafety: {
              filled:
                showZeroOrEmpty(
                  res1?.complaintsMadeByEmployeesAndWorkers
                    ?.currentFinancialYear?.healthAndSafety?.filled,
                ) ?? "",
              pending:
                showZeroOrEmpty(
                  res1?.complaintsMadeByEmployeesAndWorkers
                    ?.currentFinancialYear?.healthAndSafety?.pending,
                ) ?? "",
              remark:
                res1?.complaintsMadeByEmployeesAndWorkers?.currentFinancialYear
                  ?.healthAndSafety?.remark ?? "",
            },
          },
          previousFinancialYear: {
            workingCondition: {
              filled:
                showZeroOrEmpty(
                  res1?.complaintsMadeByEmployeesAndWorkers
                    ?.previousFinancialYear?.workingCondition?.filled,
                ) ?? "",
              pending:
                showZeroOrEmpty(
                  res1?.complaintsMadeByEmployeesAndWorkers
                    ?.previousFinancialYear?.workingCondition?.pending,
                ) ?? "",
              remark:
                res1?.complaintsMadeByEmployeesAndWorkers?.previousFinancialYear
                  ?.workingCondition?.remark ?? "",
            },
            healthAndSafety: {
              filled:
                showZeroOrEmpty(
                  res1?.complaintsMadeByEmployeesAndWorkers
                    ?.previousFinancialYear?.healthAndSafety?.filled,
                ) ?? "",
              pending:
                showZeroOrEmpty(
                  res1?.complaintsMadeByEmployeesAndWorkers
                    ?.previousFinancialYear?.healthAndSafety?.pending,
                ) ?? "",
              remark:
                res1?.complaintsMadeByEmployeesAndWorkers?.previousFinancialYear
                  ?.healthAndSafety?.remark ?? "",
            },
          },
        },
        // 14
        assessmentYear: {
          healthAndSafetyPractice:
            showZeroOrEmpty(res1?.assessmentYear?.healthAndSafetyPractice) ??
            "",
          workingCondition:
            showZeroOrEmpty(res1?.assessmentYear?.workingCondition) ?? "",
        },
        // 15
        healthAndSafetyPracticesWorking:
          res1?.healthAndSafetyPracticesWorking ?? "",
        // wellBeingMeasuresAndWorkersDoc:
        //   res1?.wellBeingMeasuresAndWorkersDoc ?? [],
        retirementBenefitsDoc: res1?.retirementBenefitsDoc ?? [],
        accessibilityUnderRPWD2016Doc:
          res1?.accessibilityUnderRPWD2016Doc ?? [],
        rightsOfPersonsDisability2016Doc:
          res1?.rightsOfPersonsDisability2016Doc ?? [],
        returnAndRetentionParentalLeaveDoc:
          res1?.returnAndRetentionParentalLeaveDoc ?? [],
        grievanceRedressalMechanismDoc:
          res1?.grievanceRedressalMechanismDoc ?? [],
        membershipInAssociationsOrUnionsDoc:
          res1?.membershipInAssociationsOrUnionsDoc ?? [],
        trainingDetailsDoc: res1?.trainingDetailsDoc ?? [],
        performanceAndCareerReviewsDoc:
          res1?.performanceAndCareerReviewsDoc ?? [],
        healthAndSafetyManagementDoc: res1?.healthAndSafetyManagementDoc ?? [],
        safetyIncidentsDoc: res1?.safetyIncidentsDoc ?? [],
        ssafetyMeasuresDoc: res1?.ssafetyMeasuresDoc ?? [],
        complaintsMadeByEmployeesAndWorkersDoc:
          res1?.complaintsMadeByEmployeesAndWorkersDoc ?? [],
        assessmentYearDoc: res1?.assessmentYearDoc ?? [],
        healthAndSafetyPracticesWorkingDoc:
          res1?.healthAndSafetyPracticesWorkingDoc ?? [],
      }));
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const generateColumnValue = (title) => {
    if (title === "% of employees covered by") {
      return [
        {
          value: "Health Insurance ",
          key: "wellBeingMeasures.otherEmployees.healthInsurance",
        },
        {
          value: "Accident Insurance",
          key: "wellBeingMeasures.otherEmployees.accidentInsurance",
        },
        {
          value: "Maternity Benefits",
          key: "wellBeingMeasures.otherEmployees.maternityBenefits",
        },
        {
          value: "Paternity Benefits ",
          key: "wellBeingMeasures.otherEmployees.paternityBenefits",
        },
        {
          value: "Day Care Facilities",
          key: "wellBeingMeasures.otherEmployees.dayCareFacilities",
        },
        // { value: "Total", key: "wellBeingMeasures.otherEmployees.Total" },
      ];
    } else if (title === "wellBeing Permanent Employees") {
      return [
        {
          value: "Health Insurance ",
          key: "wellBeingMeasures.permanentEmployees.healthInsurance",
        },
        {
          value: "Accident Insurance",
          key: "wellBeingMeasures.permanentEmployees.accidentInsurance",
        },
        {
          value: "Maternity Benefits ",
          key: "wellBeingMeasures.permanentEmployees.maternityBenefits",
        },
        {
          value: "Paternity Benefits ",
          key: "wellBeingMeasures.permanentEmployees.paternityBenefits",
        },
        {
          value: "Day Care Facilities",
          key: "wellBeingMeasures.permanentEmployees.dayCareFacilities",
        },
        // { value: "Total", key: "wellBeingMeasures.permanentEmployees.Total" },
      ];
    } else if (title === "Other than Permanent Employees") {
      return [
        {
          value: "Health Insurance ",
          key: "wellBeingMeasures.otherEmployees.healthInsurance",
        },
        {
          value: "Accident Insurance",
          key: "wellBeingMeasures.otherEmployees.accidentInsurance",
        },
        {
          value: "Maternity Benefits ",
          key: "wellBeingMeasures.otherEmployees.maternityBenefits",
        },
        {
          value: "Paternity Benefits ",
          key: "wellBeingMeasures.otherEmployees.paternityBenefits",
        },
        {
          value: "Day Care Facilities",
          key: "wellBeingMeasures.otherEmployees.dayCareFacilities",
        },
        // { value: "Total", key: "wellBeingMeasures.otherEmployees.Total" },
      ];
    } else if (title === "Permanent Workers") {
      return [
        {
          value: "Health Insurance ",
          key: "wellBeingWorkers.permanentWorkers.healthInsurance",
        },
        {
          value: "Accident Insurance",
          key: "wellBeingWorkers.permanentWorkers.accidentInsurance",
        },
        {
          value: "Maternity Benefits ",
          key: "wellBeingWorkers.permanentWorkers.maternityBenefits",
        },
        {
          value: "Paternity Benefits ",
          key: "wellBeingWorkers.permanentWorkers.paternityBenefits",
        },
        {
          value: "Day Care Facilities",
          key: "wellBeingWorkers.permanentWorkers.dayCareFacilities",
        },
        // { value: "Total", key: "wellBeingWorkers.permanentWorkers.Total" },
      ];
    } else if (title === "Other than Permanent Workers") {
      return [
        {
          value: "Health Insurance ",
          key: "wellBeingWorkers.otherWorkers.healthInsurance",
        },
        {
          value: "Accident Insurance",
          key: "wellBeingWorkers.otherWorkers.accidentInsurance",
        },
        {
          value: "Maternity Benefits ",
          key: "wellBeingWorkers.otherWorkers.maternityBenefits",
        },
        {
          value: "Paternity Benefits ",
          key: "wellBeingWorkers.otherWorkers.paternityBenefits",
        },
        {
          value: "Day Care Facilities",
          key: "wellBeingWorkers.otherWorkers.dayCareFacilities",
        },
        { value: "Total", key: "wellBeingWorkers.otherWorkers.Total" },
      ];
    } else if (title === "Current Financial Year") {
      return [
        { value: "PF", key: "retirementBenefits.currentFinancialYear.pf" },
        {
          value: "Gratuity",
          key: "retirementBenefits.currentFinancialYear.gratuity",
        },
        { value: "ESI", key: "retirementBenefits.currentFinancialYear.ESI" },
        {
          value: "Others - Please Specify",
          key: "retirementBenefits.currentFinancialYear.others",
          OptionalKey: "headerOthers",
          type: "Optional",
        },
      ];
    } else if (title === "Previous Financial Year") {
      return [
        { value: "PF", key: "retirementBenefits.previousFinancialYear.pf" },
        {
          value: "Gratuity",
          key: "retirementBenefits.previousFinancialYear.gratuity",
        },
        { value: "ESI", key: "retirementBenefits.previousFinancialYear.ESI" },
        {
          value: "Others - Please Specify",
          key: "retirementBenefits.previousFinancialYear.others",
          OptionalKey: "headerOthers",
          type: "Optional",
        },
      ];
    } else if (title === "Permanent Employees") {
      return [
        {
          value: "Male",
          key: "returnAndRetentionParentalLeave.permanentEmployees.male",
        },
        {
          value: "Female",
          key: "returnAndRetentionParentalLeave.permanentEmployees.female",
        },
        {
          value: "Total",
          key: "returnAndRetentionParentalLeave.permanentEmployees.total",
        },
      ];
    } else if (title === "returnAndRetentionParentalLeavePermanentWorkers") {
      return [
        {
          value: "Male",
          key: "returnAndRetentionParentalLeave.permanentWorkers.male",
        },
        {
          value: "Female",
          key: "returnAndRetentionParentalLeave.permanentWorkers.female",
        },
        {
          value: "Total",
          key: "returnAndRetentionParentalLeave.permanentWorkers.total",
        },
      ];
    } else if (title === "sixTable") {
      return [
        {
          value: "Permanent Employees",
          key: "grievanceRedressalMechanism.permanentEmployees",
        },
        {
          value: "Other than Permanent Employees",
          key: "grievanceRedressalMechanism.otherThanPermanentEmployees",
        },
        {
          value: "Permanent Workers",
          key: "grievanceRedressalMechanism.permanentWorkers",
        },
        {
          value: "Other than Permanent Workers",
          key: "grievanceRedressalMechanism.otherThanPermanentWorkers",
        },
      ];
    } else if (title === "Seven Current Financial year") {
      return [
        {
          value: "Permanent Employees",
          key: "membershipInAssociationsOrUnions.permanentEmployees.currentFinancialYear",
          type: "rowSpan",

          subvalue: [
            {
              value: "Male",
              key: ["totalMaleEmployees", "NoOfMaleEmployeesCategory"],
            },
            {
              value: "Female",
              key: ["totalFemaleEmployees", "NoOfFemaleEmployeesCategory"],
            },
            {
              value: "Total",
              key: ["totalEmployeesCategory", "NoofEmployeesCategory"],
            },
          ],
          PercentageKeys: [
            "totalMaleEmployeesPercentage",
            "totalfemaleEmployeesPercentage",
          ],
        },
        {
          value: "Permanent Workers",
          key: "membershipInAssociationsOrUnions.permanentWorkers.currentFinancialYear",
          type: "rowSpan",

          subvalue: [
            {
              value: "Male",
              key: ["totalMaleEmployees", "NoOfMaleEmployeesCategory"],
            },
            {
              value: "Female",
              key: ["totalFemaleEmployees", "NoOfFemaleEmployeesCategory"],
            },
            {
              value: "Total",
              key: ["totalEmployeesCategory", "NoofEmployeesCategory"],
            },
          ],
          PercentageKeys: [
            "totalMaleEmployeesPercentage",
            "totalfemaleEmployeesPercentage",
          ],
        },
      ];
    } else if (title === "Seven Pervious Financial year") {
      return [
        {
          value: "Permanent Employees",
          key: "membershipInAssociationsOrUnions.permanentEmployees.previousFinancialYear",
          type: "rowSpan",

          subvalue: [
            {
              value: "Male",
              key: ["totalMaleEmployees", "NoOfMaleEmployeesCategory"],
            },
            {
              value: "Female",
              key: ["totalFemaleEmployees", "NoOfFemaleEmployeesCategory"],
            },
            {
              value: "Total",
              key: ["totalEmployeesCategory", "NoofEmployeesCategory"],
            },
          ],
          PercentageKeys: [
            "totalMaleEmployeesPercentage",
            "totalfemaleEmployeesPercentage",
          ],
        },
        {
          value: "Permanent Workers",
          key: "membershipInAssociationsOrUnions.permanentWorkers.previousFinancialYear",
          type: "rowSpan",

          subvalue: [
            {
              value: "Male",
              key: ["totalMaleEmployees", "NoOfMaleEmployeesCategory"],
            },
            {
              value: "Female",
              key: ["totalFemaleEmployees", "NoOfFemaleEmployeesCategory"],
            },
            {
              value: "Total",
              key: ["totalEmployeesCategory", "NoofEmployeesCategory"],
            },
          ],
          PercentageKeys: [
            "totalMaleEmployeesPercentage",
            "totalfemaleEmployeesPercentage",
          ],
        },
      ];
    } else if (title === "eight Current Financial year") {
      return [
        {
          value: "Employees",
          key: "trainingDetails.currentFinancialYear.employeeTrainingUpgradation",
          type: "rowSpan",
          rows: "multiple",
          subvalue: [
            {
              value: "Male",
              key: ["totalMale", "HealthMaleNumber", "SkillMaleNumber"],
            },
            {
              value: "Female",
              key: ["totalFemale", "HealthFemaleNumber", "SkillFemaleNumber"],
            },
            { value: "Total", key: ["Total", "HealthTotal", "SkillTotal"] },
          ],
          PercentageKeys: [
            ["HealthMalePercentage", "SkillMalePercentage"],
            ["HealthFemalePercentage", "SkillFemalePercentage"],
          ],
        },
        {
          value: "Workers",
          key: "trainingDetails.currentFinancialYear.workerTrainingUpgradation",
          type: "rowSpan",
          rows: "multiple",
          subvalue: [
            {
              value: "Male",
              key: ["totalMale", "HealthMaleNumber", "SkillMaleNumber"],
            },
            {
              value: "Female",
              key: ["totalFemale", "HealthFemaleNumber", "SkillFemaleNumber"],
            },
            { value: "Total", key: ["Total", "HealthTotal", "SkillTotal"] },
          ],
          PercentageKeys: [
            ["HealthMalePercentage", "SkillMalePercentage"],
            ["HealthFemalePercentage", "SkillFemalePercentage"],
          ],
        },
      ];
    } else if (title === "eight Pervious Financial year") {
      return [
        {
          value: "Employees",
          key: "trainingDetails.previousFinancialYear.employeeTrainingUpgradation",
          type: "rowSpan",
          rows: "multiple",
          subvalue: [
            {
              value: "Male",
              key: ["totalMale", "HealthMaleNumber", "SkillMaleNumber"],
            },
            {
              value: "Female",
              key: ["totalFemale", "HealthFemaleNumber", "SkillFemaleNumber"],
            },
            { value: "Total", key: ["Total", "HealthTotal", "SkillTotal"] },
          ],
          PercentageKeys: [
            ["HealthMalePercentage", "SkillMalePercentage"],
            ["HealthFemalePercentage", "SkillFemalePercentage"],
          ],
        },
        {
          value: "Workers",
          key: "trainingDetails.previousFinancialYear.workerTrainingUpgradation",
          type: "rowSpan",
          rows: "multiple",
          subvalue: [
            {
              value: "Male",
              key: ["totalMale", "HealthMaleNumber", "SkillMaleNumber"],
            },
            {
              value: "Female",
              key: ["totalFemale", "HealthFemaleNumber", "SkillFemaleNumber"],
            },
            { value: "Total", key: ["Total", "HealthTotal", "SkillTotal"] },
          ],
          PercentageKeys: [
            ["HealthMalePercentage", "SkillMalePercentage"],
            ["HealthFemalePercentage", "SkillFemalePercentage"],
          ],
        },
      ];
    } else if (title === "nine Details") {
      return [
        {
          value: "Male",
          key: "male",
        },
        {
          value: "Female",
          key: "female",
        },
        {
          value: "Total",
          key: "total",
        },
      ];
    } else if (title === "WorkersEmployee") {
      return [
        {
          value:
            "Lost Time Injury Frequency Rate (LTIFR) (per one million-person hours worked)",
          key: "safetyIncidents.employees.lostTimeInjuryFrequencyRate",
        },
        {
          value: "Total recordable work-related injuries",
          key: "safetyIncidents.employees.totalRecordableInjuries",
        },
        {
          value: "No. of fatalities",
          key: "safetyIncidents.employees.numberOfFatalities",
        },
        {
          value:
            "High consequence work-related injury or ill-health (excluding fatalities)",
          key: "safetyIncidents.employees.highConsequenceInjuries",
        },
      ];
    } else if (title === "WorkersEmployeeEleventh") {
      return [
        {
          value:
            "Lost Time Injury Frequency Rate (LTIFR) (per one million-person hours worked)",
          key: "safetyIncidents.workers.lostTimeInjuryFrequencyRate",
        },
        {
          value: "Total recordable work-related injuries",
          key: "safetyIncidents.workers.totalRecordableInjuries",
        },
        {
          value: "No. of fatalities",
          key: "safetyIncidents.workers.numberOfFatalities",
        },
        {
          value:
            "High consequence work-related injury or ill-health (excluding fatalities)",
          key: "safetyIncidents.workers.highConsequenceInjuries",
        },
      ];
    } else if (title === "NumberOfComplaints") {
      return [
        {
          value: "Working Conditions",
          key: "complaintsMadeByEmployeesAndWorkers.currentFinancialYear.workingCondition",
        },
        {
          value: "Health & Safety",
          key: "complaintsMadeByEmployeesAndWorkers.currentFinancialYear.healthAndSafety",
        },
      ];
    } else if (title === "NumberOfComplaints13") {
      return [
        {
          value: "Working Conditions",
          key: "complaintsMadeByEmployeesAndWorkers.previousFinancialYear.workingCondition",
        },
        {
          value: "Health & Safety",
          key: "complaintsMadeByEmployeesAndWorkers.previousFinancialYear.healthAndSafety",
        },
      ];
    } else if (title === "AssessmentsYear") {
      return [
        {
          value: "Health and safety practices",
          key: "assessmentYear.healthAndSafetyPractice",
          type: "percentage",
        },
        {
          value: "Working Conditions",
          key: "assessmentYear.workingCondition",
          type: "percentage",
        },
      ];
    }
  };

  const validateFields = (obj, errorsindex) => {
    let errorObj = {}; // Start fresh to keep only unresolved errors
    Object.keys(errorsindex).forEach((errorKey) => {
      const nestedKeys = errorKey.split(".");
      const lastKey = nestedKeys[nestedKeys.length - 1]; // Extract last key
      const mainKey = nestedKeys[0]; // Always the first key
      const subKey =
        nestedKeys.length > 2
          ? nestedKeys.slice(1, -1).join(".")
          : nestedKeys[1] || ""; // Correctly get subKey (handles deeper nesting)

      // Traverse `obj` dynamically to check the field's value
      let fieldValue = obj;
      for (const key of nestedKeys) {
        if (fieldValue && typeof fieldValue === "object" && key in fieldValue) {
          fieldValue = fieldValue[key];
        } else {
          fieldValue = undefined;
          break;
        }
      }

      // If the field has a valid value, we do NOT add it to `errorObj`
      if (fieldValue !== undefined && fieldValue !== "") {
        return;
      }

      // If the field is missing or empty, add it to `errorObj`
      if (!errorObj[mainKey]) {
        errorObj[mainKey] = [];
      }
      // Special case: skip female fields in paternityBenefits, and male fields in maternityBenefits
      // Skip validation for irrelevant gender fields in maternity/paternity benefits
      if (
        (mainKey === "wellBeingWorkers" || mainKey === "wellBeingMeasures") &&
        subKey &&
        (subKey.includes("maternityBenefits") ||
          subKey.includes("paternityBenefits"))
      ) {
        console.log("wellBeingWorkers", mainKey, subKey);
        const isMaternity = subKey.includes("maternityBenefits");
        const isPaternity = subKey.includes("paternityBenefits");

        const isMaleField = lastKey === "male" || lastKey === "malePercentage";
        const isFemaleField =
          lastKey === "female" || lastKey === "femalePercentage";

        if ((isMaternity && isMaleField) || (isPaternity && isFemaleField)) {
          return; // Skip pushing this field into the error object
        }
      }

      if (mainKey === "grievanceRedressalMechanism") {
        const entry = obj?.[mainKey]?.[subKey]; // safely access the entry
        if (entry?.code === "Yes") {
          errorObj[mainKey].push({
            subkey: subKey,
            fieldName: lastKey,
            rowIndex: (errorsindex[errorKey]?.rowIndex || 0) + 1, // Handle undefined rowIndex
            message: "This field is required",
          });
        }
      } else {
        if (
          mainKey === "wellBeingMeasures" &&
          subKey?.includes("permanentEmployees")
        )
          errorObj[mainKey].push({
            subkey: subKey,
            fieldName: lastKey,
            rowIndex: (errorsindex[errorKey]?.rowIndex || 0) + 1, // Handle undefined rowIndex
            message: "This field is required",
          });
      }
    });

    // Combine male, female, and total into performanceAndCareerReviews
    // if (errorObj.male || errorObj.female || errorObj.total) {
    //   errorObj["performanceAndCareerReviews"] = [
    //     ...(errorObj.male || []),
    //     ...(errorObj.female || []),
    //     ...(errorObj.total || []),
    //   ];
    //   delete errorObj.male;
    //   delete errorObj.female;
    //   delete errorObj.total;
    // }
    console.log(errorObj, "err1");
    if (
      formData?.accessibilityUnderRPWD2016?.status &&
      !formData?.accessibilityUnderRPWD2016?.remark?.trim()
    ) {
      errorObj.accessibilityUnderRPWD2016 = {
        remark: "Remark is required",
      };
    }
    if (
      formData?.rightsOfPersonsDisability2016?.status === true ||
      formData?.rightsOfPersonsDisability2016?.status === "true"
    ) {
      const webLink = formData?.rightsOfPersonsDisability2016?.webLink?.trim();
      if (!webLink) {
        errorObj.rightsOfPersonsDisability2016 = {
          webLink: "Web link is required",
        };
      } else if (!/^https?:\/\/[\w\-]+(\.[\w\-]+)+[/#?]?.*$/.test(webLink)) {
        errorObj.rightsOfPersonsDisability2016 = {
          webLink: "Enter a valid URL",
        };
      }
    }
    if (
      Array.isArray(errorObj.grievanceRedressalMechanism) &&
      errorObj.grievanceRedressalMechanism.length === 0
    ) {
      delete errorObj.grievanceRedressalMechanism;
    }
    Object.keys(errorObj).forEach((key) => {
      if (Array.isArray(errorObj[key]) && errorObj[key].length === 0) {
        delete errorObj[key];
      }
    });
    console.log(errorObj, "errorObj");
    setErrors(errorObj); // Update errors state
    return Object.keys(errorObj).length > 0 ? errorObj : false;
  };

  const handleClick = () => {
    // const validationErrors = validateFields(formData,errorsindex);
    if (!disabled) {
      console.log(validateFields(formData, rowindex), "errorObj");
      if (validateFields(formData, rowindex)) return;
      const dataToSend = {
        type: "SectionC",
        subType: "principle3",
        essentialIndicatorsSubmitted: true,
        essentialIndicators: { ...formData },
      };
      try {
        const res = put(`/brsr/update?id=${id}`, { ...dataToSend });
        onSave();
        //  navigate("/brsr/section-c/principle4");
      } catch (error) {
        console.log(error);
        // setsnackOpen({
        //   open: true,
        //   message: error.data.message,
        //   severity: "error",
        // });
      }
    } else onSave();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (!/^\d*$/.test(value)) return;

    setFormData((prevFormData) => {
      const updatedFormData = { ...prevFormData }; // Clone the previous state

      const keys = name.split("."); // Split the path into keys
      let current = updatedFormData; // Start at the root of the formData

      // Traverse the object to the second-to-last key
      for (let i = 0; i < keys.length - 1; i++) {
        if (!current[keys[i]]) {
          current[keys[i]] = {}; // Create nested objects if they don't exist
        }
        current = current[keys[i]];
      }

      // Update the target field's value
      current[keys[keys.length - 1]] = value;

      return updatedFormData; // Return the updated state
    });
  };

  // Helper to get error message for a field
  const getErrorMessage = (path) => {
    const error = errors.find((err) => err.path === path);
    return error ? error.message : null;
  };

  return (
    <div>
      <Typography
        variant="h6"
        sx={{
          textDecoration: "underline",
          textTransform: "uppercase",
          fontWeight: "bold",
          margin: "15px 0",
        }}
      >
        I. Essential Indicator
      </Typography>
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: "bold", margin: "15px 0" }}
        gutterBottom
      >
        1. a. Details of measures for the well-being of employees:
      </Typography>
      <Box sx={{ display: "flex", gap: "10px", width: "100%" }}>
        <Box sx={{ width: "50%", mt: 2, ml: 2 }}>
          <Typography sx={{ fontFamily: "Inter", fontWeight: 500 }}>
            Total no. male employees
          </Typography>
          <Box sx={{ display: "flex", mt: 2 }}>
            <Typography sx={{ margin: "10px" }}>
              Permanent employees:
            </Typography>
            <TextField
              sx={{ margin: "10px" }}
              size="small"
              disabled={disabled}
              placeholder="Enter Number"
              name="wellBeingMeasures.maleEmployees.permanentEmployees"
              value={
                formData?.wellBeingMeasures?.maleEmployees?.permanentEmployees
              }
              onChange={(e) => handleChange(e, "number")}
              // error={errors} // Shows red border if true
              // helperText={errors?.wellBeingMeasures?.permanentEmployees?.maleEmployees} // Shows the error message below the field
              error={
                !!errors?.wellBeingMeasures?.maleEmployees?.permanentEmployees
              }
              helperText={
                errors?.wellBeingMeasures?.maleEmployees?.permanentEmployees
              }
            />
          </Box>
          <Box sx={{ display: "flex" }}>
            <Typography sx={{ margin: "10px" }}>
              Other than <br />
              permanent employees:
            </Typography>
            <TextField
              disabled={disabled}
              sx={{ margin: "10px", marginLeft: "12px" }}
              size="small"
              name="wellBeingMeasures.maleEmployees.otherEmployees"
              value={formData?.wellBeingMeasures?.maleEmployees?.otherEmployees}
              placeholder="Enter Number"
              onChange={(e) => handleChange(e, "number")}
              error={!!errors?.wellBeingMeasures?.maleEmployees?.otherEmployees}
              helperText={
                errors?.wellBeingMeasures?.maleEmployees?.otherEmployees
              }
            />
          </Box>
        </Box>
        <Box sx={{ width: "50%", mt: 2 }}>
          <Typography sx={{ fontFamily: "Inter", fontWeight: 500 }}>
            Total no. female employees
          </Typography>
          <Box sx={{ display: "flex", mt: 2 }}>
            <Typography sx={{ margin: "10px" }}>
              Permanent employees:
            </Typography>
            <TextField
              disabled={disabled}
              sx={{ margin: "10px" }}
              size="small"
              placeholder="Enter Number"
              onChange={(e) => handleChange(e, "number")}
              value={
                formData?.wellBeingMeasures?.femaleEmployees?.permanentEmployees
              }
              name="wellBeingMeasures.femaleEmployees.permanentEmployees"
              error={
                !!errors?.wellBeingMeasures?.femaleEmployees?.permanentEmployees
              }
              helperText={
                errors?.wellBeingMeasures?.femaleEmployees?.permanentEmployees
              }
            />
          </Box>
          <Box sx={{ display: "flex" }}>
            <Typography sx={{ margin: "10px" }}>
              Other than <br />
              permanent employees:
            </Typography>
            <TextField
              disabled={disabled}
              sx={{ margin: "10px", marginLeft: "12px" }}
              size="small"
              placeholder="Enter Number"
              onChange={(e) => handleChange(e, "number")}
              name="wellBeingMeasures.femaleEmployees.otherEmployees"
              value={
                formData?.wellBeingMeasures?.femaleEmployees?.otherEmployees
              }
              error={
                !!errors?.wellBeingMeasures?.femaleEmployees?.otherEmployees
              }
              helperText={
                errors?.wellBeingMeasures?.femaleEmployees?.otherEmployees
              }
            />
          </Box>
        </Box>
        <Box></Box>
      </Box>
      <Box sx={{ marginLeft: "1rem" }}>
        <EmpTable
          heading={heading}
          disabled={disabled}
          columnWidth={"21% 20% 20% 19% 20%"}
          // columnValue={columnValue}
          columnValue={generateColumnValue("wellBeing Permanent Employees")}
          title={"Permanent Employees"}
          formValues={formData}
          setFormValues={setFormData}
          errorsindex={rowindex}
          setRowIndex={setRowIndex}
          setErrors={setErrors}
          errors={
            errors?.wellBeingMeasures?.filter((item) =>
              `${item.subkey}`.includes("permanentEmployees"),
            ) || ""
          }
          // topHeading={"Permanent Employees"}
          // topheader={"20.Details at the end of Financial Year"}
        />
        {/* {Object.keys(errors?.wellBeingMeasures?.permanentEmployees || {}).length >
        0 && (
        <p style={{ color: "red" }}>
          Please fill out all mandatory fields in Permanent Employees.
        </p>
      )} */}
        {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
        <EmpTable
          heading={heading}
          columnWidth={"21% 20% 20% 19% 20%"}
          disabled={disabled}
          // columnValue={columnValue}
          columnValue={generateColumnValue("% of employees covered by")}
          title={"Other than Permanent Employees"}
          formValues={formData}
          setFormValues={setFormData}
          setRowIndex={setRowIndex}
          errorsindex={rowindex}
          setErrors={setErrors}
          errors={errors?.wellBeingMeasures?.filter((item) =>
            `${item.subkey}`.includes("otherEmployees"),
          )}
          // topHeading={"Permanent Employees"}
          // topheader={"20.Details at the end of Financial Year"}
        />
      </Box>
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: "bold", margin: "15px 0" }}
        gutterBottom
      >
        1 b. Details of measures for the well-being of workers:
      </Typography>
      <Box sx={{ display: "flex", gap: "10px", width: "100%" }}>
        <Box sx={{ width: "50%", marginLeft: "1rem", mt: 2 }}>
          <Typography sx={{ fontFamily: "Inter", fontWeight: 500 }}>
            Total no. male workers
          </Typography>
          <Box sx={{ display: "flex", mt: 2 }}>
            <Typography sx={{ margin: "10px" }}>Permanent workers:</Typography>
            <TextField
              disabled={disabled}
              sx={{ margin: "10px" }}
              size="small"
              placeholder="Enter Number"
              name="wellBeingWorkers.maleEmployees.permanentWorkers"
              value={
                formData?.wellBeingWorkers?.maleEmployees?.permanentWorkers
              }
              onChange={(e) => handleChange(e, "number")}
              // error={errors} // Shows red border if true
              // helperText={errors?.wellBeingWorkers?.permanentWorkers?.maleEmployees} // Shows the error message below the field
              error={
                !!errors?.wellBeingWorkers?.maleEmployees?.permanentWorkers
              }
              helperText={
                errors?.wellBeingWorkers?.maleEmployees?.permanentWorkers
              }
            />
          </Box>
          <Box sx={{ display: "flex" }}>
            <Typography sx={{ margin: "10px" }}>
              Other than <br />
              permanent workers:
            </Typography>
            <TextField
              disabled={disabled}
              sx={{ margin: "10px", marginLeft: "12px" }}
              size="small"
              name="wellBeingWorkers.maleEmployees.otherWorkers"
              value={formData?.wellBeingWorkers?.maleEmployees?.otherWorkers}
              placeholder="Enter Number"
              onChange={(e) => handleChange(e, "number")}
              error={!!errors?.wellBeingWorkers?.maleEmployees?.otherWorkers}
              helperText={errors?.wellBeingWorkers?.maleEmployees?.otherWorkers}
            />
          </Box>
        </Box>
        <Box sx={{ width: "50%", mt: 2 }}>
          <Typography sx={{ fontFamily: "Inter", fontWeight: 500 }}>
            Total no. female workers
          </Typography>
          <Box sx={{ display: "flex", mt: 2 }}>
            <Typography sx={{ margin: "10px" }}>Permanent workers:</Typography>
            <TextField
              disabled={disabled}
              sx={{ margin: "10px" }}
              size="small"
              placeholder="Enter Number"
              onChange={(e) => handleChange(e, "number")}
              value={
                formData?.wellBeingWorkers?.femaleEmployees?.permanentWorkers
              }
              name="wellBeingWorkers.femaleEmployees.permanentWorkers"
              error={
                !!errors?.wellBeingWorkers?.femaleEmployees?.permanentWorkers
              }
              helperText={
                errors?.wellBeingWorkers?.femaleEmployees?.permanentWorkers
              }
            />
          </Box>
          <Box sx={{ display: "flex" }}>
            <Typography sx={{ margin: "10px" }}>
              Other than <br />
              permanent workers:
            </Typography>
            <TextField
              disabled={disabled}
              sx={{ margin: "10px", marginLeft: "12px" }}
              size="small"
              placeholder="Enter Number"
              onChange={(e) => handleChange(e, "number")}
              name="wellBeingWorkers.femaleEmployees.otherWorkers"
              value={formData?.wellBeingWorkers?.femaleEmployees?.otherWorkers}
              error={!!errors?.wellBeingWorkers?.femaleEmployees?.otherWorkers}
              helperText={
                errors?.wellBeingWorkers?.femaleEmployees?.otherWorkers
              }
            />
          </Box>
        </Box>
      </Box>
      <Box sx={{ marginLeft: "1rem" }}>
        <EmpTable
          heading={headingWorker}
          columnWidth={"21% 20% 20% 19% 20%"}
          disabled={disabled}
          // columnValue={columnValue}
          columnValue={generateColumnValue("Permanent Workers")}
          title={"Permanent Workers"}
          formValues={formData}
          setFormValues={setFormData}
          setRowIndex={setRowIndex}
          errorsindex={rowindex}
          setErrors={setErrors}
          errors={errors?.wellBeingWorkers?.filter((item) =>
            `${item.subkey}`.includes("permanentWorkers"),
          )}
          // topHeading={"Permanent Employees"}
          // topheader={"20.Details at the end of Financial Year"}
        />
        {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
        <EmpTable
          heading={headingWorker}
          columnWidth={"21% 20% 20% 19% 20%"}
          disabled={disabled}
          // columnValue={columnValue}
          columnValue={generateColumnValue("Other than Permanent Workers")}
          title={"Other than Permanent Workers"}
          formValues={formData}
          setFormValues={setFormData}
          setRowIndex={setRowIndex}
          errorsindex={rowindex}
          setErrors={setErrors}
          errors={errors?.wellBeingWorkers?.filter((item) =>
            `${item.subkey}`.includes("otherWorkers"),
          )}
          // topHeading={"Permanent Employees"}
          // topheader={"20.Details at the end of Financial Year"}
        />
        {/* {Object.keys(errors?.wellBeingWorkers?.otherWorkers || {}).length > 0 && (
        <p style={{ color: "red" }}>
          Please fill out all mandatory fields in Permanent Workers.
        </p>
      )} */}
      </Box>
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: "bold", margin: "15px 0", marginTop: "2rem" }}
        gutterBottom
      >
        1 c.Spending on measures towards well-being of employees and workers
        (including permanent and other than permanent) in the following format
      </Typography>
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: "bold", marginLeft: "1.4rem" }}
        gutterBottom
      >
        Cost incurred on wellbeing measures as a % of total revenue of the
        company
      </Typography>
      <Box
        sx={{
          display: "flex",
          gap: "1.5rem",
          width: "100%",
          marginLeft: "1.5rem",
        }}
      >
        <Box sx={{ width: "48%" }}>
          <Box sx={{ display: "", mt: 2 }}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "500" }}
              gutterBottom
            >
              In Current Financial
            </Typography>
            <TextField
              disabled={disabled}
              size="small"
              fullWidth
              placeholder="Enter Amount"
              value={formData?.wellBeingMeasuresCurrent || ""}
              onChange={(e) => {
                const val = e.target.value;

                // Allow only numeric values or empty string
                if (!/^\d*$/.test(val)) return;

                // If the field is being cleared (empty string), allow it
                if (val === "") {
                  setFormData((prev) => ({
                    ...prev,
                    wellBeingMeasuresCurrent: "",
                  }));
                  return;
                }

                // Convert to number and check range only if there's a value
                const numVal = Number(val);
                if (numVal <= 0 || numVal > 100) return;

                setFormData((prev) => ({
                  ...prev,
                  wellBeingMeasuresCurrent: val,
                }));
              }}
            />
          </Box>
        </Box>
        <Box sx={{ width: "48%" }}>
          <Box sx={{ display: "", mt: 2 }}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "500" }}
              gutterBottom
            >
              In Previous Financial Year
            </Typography>
            <TextField
              disabled={disabled}
              size="small"
              fullWidth
              placeholder="Enter Amount"
              value={formData?.wellBeingMeasuresPrevious || ""}
              onChange={(e) => {
                const val = e.target.value;
                if (!/^\d*$/.test(val)) return; // Allow only numeric values
                if (val === "") {
                  setFormData((prev) => ({
                    ...prev,
                    wellBeingMeasuresPrevious: "",
                  }));
                  return;
                }
                // if (type==="number" && !/^\d*$/.test(value)) return; // Allow only numeric values

                if (val <= 0 || val > 100) {
                  return;
                }

                setFormData((prev) => ({
                  ...prev,
                  wellBeingMeasuresPrevious: val,
                }));
              }}
            />
          </Box>
        </Box>
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "wellBeingMeasuresAndWorkersDoc",
          ml: 3,
          removeUpload,
        }}
      />
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <Box>
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: "bold", marginTop: "2rem" }}
          gutterBottom
        >
          2. Details of retirement Benefits , for Current FY and Previous
          Financial Year.
        </Typography>
        <Box sx={{ marginLeft: "1rem", marginTop: "-0.5rem" }}>
          <EmpTable
            heading={headingretirementBenefits}
            disabled={disabled}
            columnWidth={"25% 25% 25% 25% "}
            // columnValue={columnValue}
            columnValue={generateColumnValue("Current Financial Year")}
            title={"a.Current Financial Year"}
            formValues={formData}
            setFormValues={setFormData}
            setRowIndex={setRowIndex}
            errorsindex={rowindex}
            placehold="Enter %"
            setErrors={setErrors}
            errors={errors?.retirementBenefits?.filter((item) =>
              `${item.subkey}`.includes("currentFinancialYear"),
            )}
            // topHeading={"Permanent Employees"}
            // topheader={"20.Details at the end of Financial Year"}
          />
          {/* {Object.keys(errors?.retirementBenefits?.currentFinancialYear || {})
          .length > 0 && (
          <p style={{ color: "red" }}>
            Please fill out all mandatory fields in Current Financial Year.
          </p>
        )} */}
          <EmpTable
            disabled={disabled}
            heading={headingretirementBenefits}
            columnWidth={"25% 25% 25% 25% "}
            // columnValue={columnValue}
            columnValue={generateColumnValue("Previous Financial Year")}
            title={"b.Previous Financial Year"}
            formValues={formData}
            setFormValues={setFormData}
            setRowIndex={setRowIndex}
            errorsindex={rowindex}
            placehold="Enter %"
            setErrors={setErrors}
            errors={errors?.retirementBenefits?.filter((item) =>
              `${item.subkey}`.includes("previousFinancialYear"),
            )}
            // topHeading={"Permanent Employees"}
            // topheader={"20.Details at the end of Financial Year"}
          />
          {/* {Object.keys(errors?.retirementBenefits?.previousFinancialYear || {})
          .length > 0 && (
          <p style={{ color: "red" }}>
            Please fill out all mandatory fields in Previous Financial Year.
          </p>
        )} */}
        </Box>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData,
            setFormData,
            errors,
            setErrors,
            Uploadkey: "retirementBenefitsDoc",
            ml: 3,
            removeUpload,
          }}
        />
      </Box>
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <Box sx={{ mt: 2, marginTop: "2rem" }}>
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: "bold", textIndent: "-1rem", marginLeft: "1rem" }}
          gutterBottom
        >
          3. Are the premises / offices of the entity accessible to differently
          abled employees and workers, as per the requirements of the Rights of
          Persons with Disabilities Act, 2016? If not, whether any steps are
          being taken by the entity in this regard.
        </Typography>
        <Box sx={{ marginLeft: "1rem" }}>
          <RadioGroup
            disabled={disabled}
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: "0px",
              padding: "0px 5px",
            }}
            value={
              formData?.accessibilityUnderRPWD2016?.status === true
                ? "Yes"
                : "No"
            }
            defaultValue={formData?.accessibilityUnderRPWD2016?.status} // Set the default selected value
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                accessibilityUnderRPWD2016: {
                  ...prev.accessibilityUnderRPWD2016,
                  remark:
                    e.target.value === "No"
                      ? ""
                      : prev.accessibilityUnderRPWD2016.remark,
                  status: e.target.value === "Yes" ? true : false, // ✅ Updates status properly
                },
              }))
            }
          >
            {["Yes", "No"].map((item, index) => (
              <FormControlLabel
                key={index}
                control={<Radio value={item} disabled={disabled} />}
                label={item}
              />
            ))}
          </RadioGroup>
          {formData?.accessibilityUnderRPWD2016?.status ? (
            <>
              <Typography
                sx={{
                  margin: "0.3rem 0rem",
                  fontFamily: "Inter",
                  fontWeight: 500,
                }}
              >
                Steps taken by the entity
              </Typography>
              <TextField
                fullWidth
                disabled={disabled}
                placeholder="Type Here"
                value={formData?.accessibilityUnderRPWD2016?.remark}
                sx={{
                  "& .MuiInputBase-root": {
                    height: 80,
                  },
                }}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    accessibilityUnderRPWD2016: {
                      ...prev.accessibilityUnderRPWD2016,
                      remark: e.target.value, // ✅ Updates status properly
                    },
                  }))
                }
                error={!!errors?.accessibilityUnderRPWD2016?.remark}
                helperText={errors?.accessibilityUnderRPWD2016?.remark}
              />
            </>
          ) : null}
        </Box>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData,
            setFormData,
            errors,
            setErrors,
            Uploadkey: "accessibilityUnderRPWD2016Doc",
            ml: 3,
            removeUpload,
          }}
        />
      </Box>
      <Box sx={{ mt: 2 }}>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "bold",
            marginTop: "2rem",
            textIndent: "-1rem",
            marginLeft: "1rem",
          }}
          gutterBottom
        >
          4. Does the entity have an equal opportunity policy as per the Rights
          of Persons with Disabilities Act, 2016? If so, provide a web-link to
          the policy.
        </Typography>
        <Box sx={{ marginLeft: "1rem" }}>
          <RadioGroup
            disabled={disabled}
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: "0px",
            }}
            value={
              formData?.rightsOfPersonsDisability2016?.status === true
                ? "Yes"
                : "No"
            }
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                rightsOfPersonsDisability2016: {
                  ...prev.rightsOfPersonsDisability2016,
                  webLink:
                    e.target.value === "No"
                      ? ""
                      : prev.rightsOfPersonsDisability2016.webLink,
                  status: e.target.value === "Yes" ? true : false, // ✅ Updates status properly
                },
              }))
            }
            defaultValue={
              formData?.rightsOfPersonsDisability2016?.status === true
                ? "Yes"
                : "No"
            } // Set the default selected value
          >
            {["Yes", "No"].map((item, index) => (
              <FormControlLabel
                key={index}
                control={<Radio value={item} disabled={disabled} />}
                label={item}
              />
            ))}
          </RadioGroup>
          {formData?.rightsOfPersonsDisability2016?.status === true ? (
            <>
              <Typography
                sx={{
                  margin: "0.3rem 0rem",
                  fontFamily: "Inter",
                  fontWeight: 500,
                }}
              >
                Web Link
              </Typography>
              <TextField
                sx={{ width: "50%" }}
                size="small"
                placeholder="Type Here"
                value={formData?.rightsOfPersonsDisability2016?.webLink}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    rightsOfPersonsDisability2016: {
                      ...prev.rightsOfPersonsDisability2016,
                      webLink: e.target.value, // ✅ Updates status properly
                    },
                  }))
                }
                error={!!errors?.rightsOfPersonsDisability2016?.webLink}
                helperText={errors?.rightsOfPersonsDisability2016?.webLink}
              />
            </>
          ) : null}
        </Box>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData,
            setFormData,
            errors,
            setErrors,
            Uploadkey: "rightsOfPersonsDisability2016Doc",
            ml: 3,
            removeUpload,
          }}
        />
      </Box>
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <Box sx={{ mt: 2 }}>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "bold",
            marginTop: "2rem",
            textIndent: "-1rem",
            marginLeft: "1rem",
          }}
          gutterBottom
        >
          5. Return to work and Retention rates of permanent employees and
          workers that took parental leave.
        </Typography>
        <Box sx={{ margin: "-0.7rem 0rem 0rem 1rem" }}>
          <EmpTable
            heading={headingreturnAndRetentionParentalLeave}
            columnWidth={"34% 33% 33%"}
            disabled={disabled}
            // columnValue={columnValue}
            columnValue={generateColumnValue("Permanent Employees")}
            title={"a.Permanent Employees"}
            formValues={formData}
            setFormValues={setFormData}
            setRowIndex={setRowIndex}
            errorsindex={rowindex}
            placehold="Enter %"
            setErrors={setErrors}
            errors={errors?.returnAndRetentionParentalLeave?.filter((item) =>
              `${item.subkey}`.includes("permanentEmployees"),
            )}
            // topHeading={"Permanent Employees"}
            // topheader={"20.Details at the end of Financial Year"}
          />
          <EmpTable
            heading={headingreturnAndRetentionParentalLeave}
            columnWidth={"34% 33% 33%"}
            disabled={disabled}
            // columnValue={columnValue}
            columnValue={generateColumnValue(
              "returnAndRetentionParentalLeavePermanentWorkers",
            )}
            title={"b.Permanent Workers"}
            formValues={formData}
            setFormValues={setFormData}
            setRowIndex={setRowIndex}
            placehold="Enter %"
            errorsindex={rowindex}
            setErrors={setErrors}
            errors={errors?.returnAndRetentionParentalLeave?.filter((item) =>
              `${item.subkey}`.includes("permanentWorkers"),
            )}
            // topHeading={"Permanent Employees"}
            // topheader={"20.Details at the end of Financial Year"}
          />
        </Box>
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "returnAndRetentionParentalLeaveDoc",
          ml: 3,
          removeUpload,
        }}
      />
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <Box sx={{ mt: 2 }}>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "bold",
            marginTop: "2rem",
            textIndent: "-1rem",
            marginLeft: "1rem",
          }}
          gutterBottom
        >
          6. Is there a mechanism available to receive and redress grievances
          for the following categories of employees and worker? If yes, give
          details of the mechanism in brief.
        </Typography>
        <Box sx={{ marginLeft: "1rem", marginTop: "-0.5rem" }}>
          <EssentialTables
            heading={headingMechanism}
            disabled={disabled}
            columnWidth={"34% 33% 33%"}
            // columnValue={columnValue}
            columnValue={generateColumnValue("sixTable")}
            title={""}
            formValues={formData}
            setFormValues={setFormData}
            setRowIndex={setRowIndex}
            errorsindex={rowindex}
            setErrors={setErrors}
            errors={errors?.grievanceRedressalMechanism?.filter(
              (item) => `${item.subkey}`,
            )}
            // topHeading={"Permanent Employees"}
            // topheader={"20.Details at the end of Financial Year"}
          />
        </Box>
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "grievanceRedressalMechanismDoc",
          ml: 3,
          removeUpload,
        }}
      />
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <Box sx={{ mt: 2 }}>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "bold",
            marginTop: "2rem",
            textIndent: "-1rem",
            marginLeft: "1rem",
          }}
          gutterBottom
        >
          7. Membership of employees and worker in association(s) or Unions
          recognized by the listed entity:
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: "bold", marginLeft: "1rem", marginTop: "0.5rem" }}
          gutterBottom
        >
          a.Current Financial Year
        </Typography>
        <Box sx={{ marginLeft: "1rem" }}>
          <TablecolSpan
            heading={headingEmployeeWorker}
            disabled={disabled}
            // columnWidth={"34% 33% 33%"}
            columnWidth={"23% 14% 26% 26% 11%"}
            columnValue={generateColumnValue("Seven Current Financial year")}
            title={""}
            formValues={formData}
            setFormValues={setFormData}
            setErrors={setErrors}
            errorsindex={rowindex}
            setRowIndex={setRowIndex}
            errors={{
              employees:
                errors?.membershipInAssociationsOrUnions
                  ?.filter((item) =>
                    `${item.subkey}`.includes(
                      "permanentEmployees.currentFinancialYear",
                    ),
                  )
                  ?.reduce((acc, item) => {
                    if (!acc[item.rowIndex]) {
                      acc[item.rowIndex] = [];
                    }
                    acc[item.rowIndex].push(item);
                    return acc;
                  }, {}) ?? {}, // Group by rowIndex and fallback to empty object
              workers:
                errors?.membershipInAssociationsOrUnions
                  ?.filter((item) =>
                    `${item.subkey}`.includes(
                      "permanentWorkers.currentFinancialYear",
                    ),
                  )
                  ?.reduce((acc, item) => {
                    if (!acc[item.rowIndex]) {
                      acc[item.rowIndex] = [];
                    }
                    acc[item.rowIndex].push(item);
                    return acc;
                  }, {}) ?? {}, // Group by rowIndex and fallback to empty object
            }}
            // errors={{
            //   employees: errors?.membershipInAssociationsOrUnions?.filter((item) =>
            //     `${item.subkey}`.includes("permanentEmployees.currentFinancialYear")
            //   ),
            //   workers: errors?.membershipInAssociationsOrUnions?.filter((item) =>
            //     `${item.subkey}`.includes("permanentWorkers.currentFinancialYear")
            //   ),
            // }}
            // topHeading={"Permanent Employees"}
            // topheader={"20.Details at the end of Financial Year"}
          />
          {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", marginTop: "1.5rem" }}
            gutterBottom
          >
            b.Previous Financial Year
          </Typography>
          <TablecolSpan
            heading={headingEmployeeWorker}
            disabled={disabled}
            // columnWidth={"34% 33% 33%"}
            columnWidth={"23% 14% 26% 26% 11%"}
            columnValue={generateColumnValue("Seven Pervious Financial year")}
            title={""}
            formValues={formData}
            setFormValues={setFormData}
            setErrors={setErrors}
            errorsindex={rowindex}
            setRowIndex={setRowIndex}
            errors={{
              employees:
                errors?.membershipInAssociationsOrUnions
                  ?.filter((item) =>
                    `${item.subkey}`.includes(
                      "permanentEmployees.previousFinancialYear",
                    ),
                  )
                  ?.reduce((acc, item) => {
                    if (!acc[item.rowIndex]) {
                      acc[item.rowIndex] = [];
                    }
                    acc[item.rowIndex].push(item);
                    return acc;
                  }, {}) ?? {}, // Group by rowIndex and fallback to empty object
              workers:
                errors?.membershipInAssociationsOrUnions
                  ?.filter((item) =>
                    `${item.subkey}`.includes(
                      "permanentWorkers.previousFinancialYear",
                    ),
                  )
                  ?.reduce((acc, item) => {
                    if (!acc[item.rowIndex]) {
                      acc[item.rowIndex] = [];
                    }
                    acc[item.rowIndex].push(item);
                    return acc;
                  }, {}) ?? {}, // Group by rowIndex and fallback to empty object
            }}
            // errors={errors?.membershipInAssociationsOrUnions?.filter((item) =>
            //   `${item.subkey}`.includes("previousFinancialYear"))}
            // topHeading={"Permanent Employees"}
            // topheader={"20.Details at the end of Financial Year"}
          />
        </Box>
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "membershipInAssociationsOrUnionsDoc",
          ml: 3,
          removeUpload,
        }}
      />
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <Box sx={{ mt: 2 }}>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "bold",
            marginTop: "2rem",
            textIndent: "-1rem",
            marginLeft: "1rem",
          }}
          gutterBottom
        >
          8.Details of training given to employees and workers:
        </Typography>
        <Box sx={{ marginLeft: "1rem" }}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", margin: "15px 0" }}
            gutterBottom
          >
            a. Current Financial Year
          </Typography>

          <TablecolSpan
            heading={headingEmployeesWorker}
            disabled={disabled}
            // columnWidth={"34% 33% 33%"}
            columnWidth={"23% 14% 26% 26% 11%"}
            columnValue={generateColumnValue("eight Current Financial year")}
            title={""}
            formValues={formData}
            setFormValues={setFormData}
            setErrors={setErrors}
            errorsindex={rowindex}
            setRowIndex={setRowIndex}
            errors={{
              employees:
                errors?.trainingDetails
                  ?.filter((item) =>
                    `${item.subkey}`.includes(
                      "currentFinancialYear.employeeTrainingUpgradation",
                    ),
                  )
                  ?.reduce((acc, item) => {
                    if (!acc[item.rowIndex]) {
                      acc[item.rowIndex] = [];
                    }
                    acc[item.rowIndex].push(item);
                    return acc;
                  }, {}) ?? {}, // Group by rowIndex and fallback to empty object
              workers:
                errors?.trainingDetails
                  ?.filter((item) =>
                    `${item.subkey}`.includes(
                      "currentFinancialYear.workerTrainingUpgradation",
                    ),
                  )
                  ?.reduce((acc, item) => {
                    if (!acc[item.rowIndex]) {
                      acc[item.rowIndex] = [];
                    }
                    acc[item.rowIndex].push(item);
                    return acc;
                  }, {}) ?? {}, // Group by rowIndex and fallback to empty object
            }}
            // topHeading={"Permanent Employees"}
            // topheader={"20.Details at the end of Financial Year"}
          />
          {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", margin: "15px 0" }}
            gutterBottom
          >
            b.Previous Financial Year
          </Typography>
          <TablecolSpan
            disabled={disabled}
            heading={headingEmployeesWorker}
            // columnWidth={"34% 33% 33%"}
            columnWidth={"23% 14% 26% 26% 11%"}
            columnValue={generateColumnValue("eight Pervious Financial year")}
            title={""}
            formValues={formData}
            setFormValues={setFormData}
            setErrors={setErrors}
            errorsindex={rowindex}
            setRowIndex={setRowIndex}
            errors={{
              employees:
                errors?.trainingDetails
                  ?.filter((item) =>
                    `${item.subkey}`.includes(
                      "previousFinancialYear.employeeTrainingUpgradation",
                    ),
                  )
                  ?.reduce((acc, item) => {
                    if (!acc[item.rowIndex]) {
                      acc[item.rowIndex] = [];
                    }
                    acc[item.rowIndex].push(item);
                    return acc;
                  }, {}) ?? {}, // Group by rowIndex and fallback to empty object
              workers:
                errors?.trainingDetails
                  ?.filter((item) =>
                    `${item.subkey}`.includes(
                      "previousFinancialYear.workerTrainingUpgradation",
                    ),
                  )
                  ?.reduce((acc, item) => {
                    if (!acc[item.rowIndex]) {
                      acc[item.rowIndex] = [];
                    }
                    acc[item.rowIndex].push(item);
                    return acc;
                  }, {}) ?? {}, // Group by rowIndex and fallback to empty object
            }}
            // topHeading={"Permanent Employees"}
            // topheader={"20.Details at the end of Financial Year"}
          />
        </Box>
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "trainingDetailsDoc",
          ml: 3,
          removeUpload,
        }}
      />
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <Box sx={{ mt: 2 }}>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "bold",
            marginTop: "2rem",
            textIndent: "-1rem",
            marginLeft: "1rem",
          }}
          gutterBottom
        >
          9. Details of performance and career development reviews of employees
          and worker:
        </Typography>

        <Typography
          variant="subtitle1"
          sx={{ fontWeight: "bold", marginLeft: "1.2rem" }}
          gutterBottom
        >
          a. Employees
        </Typography>
        <ul>
          <li
            style={{
              color: "#EB7E0E",
              margin: "1rem 0rem -0.5rem 1rem",
              fontSize: "15px",
              lineHeight: "22px",
              fontFamily: "inter",
              fontWeight: 600,
            }}
          >
            In Current Financial Year
          </li>

          <EmpTableData
            heading={headingPerformance}
            columnWidth={"25% 25% 25% 25%"}
            disabled={disabled}
            // columnValue={columnValue}
            columnValue={generateColumnValue("nine Details")}
            // title={"Other than Permanent Workers"}
            formValues={formData}
            setFormValues={setFormData}
            setErrors={setErrors}
            errorsindex={rowindex}
            setRowIndex={setRowIndex}
            //  errors={errors}
            errors={errors?.performanceAndCareerReviews?.filter((item) =>
              `${item.subkey}`.includes("employee.currentFinancialYear"),
            )}
            // topHeading={"Permanent Employees"}
            // topheader={"20.Details at the end of Financial Year"}
          />
          <li
            style={{
              color: "#EB7E0E",
              margin: "1rem 0rem -0.5rem 1rem",
              fontSize: "15px",
              lineHeight: "22px",
              fontFamily: "inter",
              fontWeight: 600,
            }}
          >
            In Previous Financial Year
          </li>
          <EmpTableData
            heading={headingPerformancepreviousFinancialYear}
            columnWidth={"25% 25% 25% 25%"}
            disabled={disabled}
            // columnValue={columnValue}
            columnValue={generateColumnValue("nine Details")}
            // title={"Other than Permanent Workers"}
            formValues={formData}
            setErrors={setErrors}
            errorsindex={rowindex}
            setRowIndex={setRowIndex}
            errors={errors?.performanceAndCareerReviews?.filter((item) =>
              `${item.subkey}`.includes("employee.previousFinancialYear"),
            )}
            setFormValues={setFormData}
            // topHeading={"Permanent Employees"}
            // topheader={"20.Details at the end of Financial Year"}
          />
        </ul>
        {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: "bold", marginTop: "2rem", marginLeft: "1.2rem" }}
          gutterBottom
        >
          b.Workers
        </Typography>
        <ul>
          <li
            style={{
              color: "#EB7E0E",
              margin: "1rem 0rem -0.5rem 1rem",
              fontSize: "15px",
              lineHeight: "22px",
              fontFamily: "inter",
              fontWeight: 600,
            }}
          >
            In Current Financial Year
          </li>
          <EmpTableData
            heading={headingPerformanceWorkers}
            disabled={disabled}
            columnWidth={"25% 25% 25% 25%"}
            // columnValue={columnValue}
            columnValue={generateColumnValue("nine Details")}
            // title={"Other than Permanent Workers"}
            formValues={formData}
            setFormValues={setFormData}
            setErrors={setErrors}
            errorsindex={rowindex}
            setRowIndex={setRowIndex}
            errors={errors?.performanceAndCareerReviews?.filter((item) =>
              `${item.subkey}`.includes("workers.currentFinancialYear"),
            )}
            // errors={errors}

            // topHeading={"Permanent Employees"}
            // topheader={"20.Details at the end of Financial Year"}
          />
          <li
            style={{
              color: "#EB7E0E",
              margin: "1rem 0rem -0.5rem 1rem",
              fontSize: "15px",
              lineHeight: "22px",
              fontFamily: "inter",
              fontWeight: 600,
            }}
          >
            In Previous Financial Year
          </li>
          <EmpTableData
            disabled={disabled}
            heading={headingPerformanceWorkerspreviousFinancialYear}
            columnWidth={"25% 25% 25% 25%"}
            // columnValue={columnValue}
            columnValue={generateColumnValue("nine Details")}
            // title={"Other than Permanent Workers"}
            formValues={formData}
            setFormValues={setFormData}
            setErrors={setErrors}
            errorsindex={rowindex}
            setRowIndex={setRowIndex}
            errors={errors?.performanceAndCareerReviews?.filter((item) =>
              `${item.subkey}`.includes("workers.previousFinancialYear"),
            )}
            // errors={errors}
            // topHeading={"Permanent Employees"}
            // topheader={"20.Details at the end of Financial Year"}
          />
        </ul>
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "performanceAndCareerReviewsDoc",
          ml: 3,
          removeUpload,
        }}
      />
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <Box sx={{ mt: 2 }}>
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: "bold", marginTop: "2rem" }}
          gutterBottom
        >
          10. Health and safety management system:
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: "bold", textIndent: "-1rem", marginLeft: "2rem" }}
          gutterBottom
        >
          a. Whether an occupational health and safety management system has
          been implemented by the entity? (Yes/ No). If yes, the coverage such
          system?
        </Typography>
        <RadioGroup
          disabled={disabled}
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "0px",
            padding: "0px 5px",
            marginLeft: "2rem",
          }}
          value={
            formData?.healthAndSafetyManagement?.occupationalHealthAndSafety
              ?.status === true
              ? "Yes"
              : "No"
          }
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              healthAndSafetyManagement: {
                ...prev.healthAndSafetyManagement,
                occupationalHealthAndSafety: {
                  ...prev.healthAndSafetyManagement.occupationalHealthAndSafety,
                  status: e.target.value === "Yes" ? true : false, // ✅ Updates status properly
                },
              },
            }))
          }
          defaultValue="Yes" // Set the default selected value
        >
          {["Yes", "No"].map((item, index) => (
            <FormControlLabel
              key={index}
              control={<Radio value={item} disabled={disabled} />}
              label={item}
            />
          ))}
        </RadioGroup>
        {formData?.healthAndSafetyManagement?.occupationalHealthAndSafety
          ?.status === true ? (
          <>
            {" "}
            <Box sx={{ ml: 4 }}>
              <Typography>Explain here</Typography>
              <TextField
                disabled={disabled}
                fullWidth
                multiline
                rows={3}
                placeholder="Type Here"
                value={
                  formData?.healthAndSafetyManagement
                    ?.occupationalHealthAndSafety?.remark
                }
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    healthAndSafetyManagement: {
                      ...prev.healthAndSafetyManagement,
                      occupationalHealthAndSafety: {
                        ...prev.healthAndSafetyManagement
                          .occupationalHealthAndSafety,
                        remark: e.target.value,
                      },
                    },
                  }))
                }
              />
            </Box>
          </>
        ) : null}
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "bold",
            marginTop: "1rem",
            textIndent: "-1rem",
            marginLeft: "2rem",
          }}
          gutterBottom
        >
          b. What are the processes used to identify work-related hazards and
          assess risks on a routine and non-routine basis by the entity?
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={3}
          disabled={disabled}
          sx={{ marginLeft: "2rem", width: "98%" }}
          value={
            formData?.healthAndSafetyManagement?.workRelatedHazardAssessment
              ?.remark
          }
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              healthAndSafetyManagement: {
                ...prev.healthAndSafetyManagement,
                workRelatedHazardAssessment: {
                  ...prev.healthAndSafetyManagement.workRelatedHazardAssessment,
                  remark: e.target.value, // ✅ Updates status properly
                },
              },
            }))
          }
          placeholder="Type Here"
        />
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "bold",
            marginTop: "1rem",
            textIndent: "-1rem",
            marginLeft: "2rem",
          }}
          gutterBottom
        >
          c. Whether you have processes for workers to report the work related
          hazards and to remove themselves from such risks.
        </Typography>
        <RadioGroup
          disabled={disabled}
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "0px",
            padding: "0px 5px",
            marginLeft: "2rem",
          }}
          value={
            formData?.healthAndSafetyManagement
              ?.hazardReportingAndSelfRemovalProcess?.status === true
              ? "Yes"
              : "No"
          }
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              healthAndSafetyManagement: {
                ...prev.healthAndSafetyManagement,
                hazardReportingAndSelfRemovalProcess: {
                  ...prev.healthAndSafetyManagement
                    .hazardReportingAndSelfRemovalProcess,
                  status: e.target.value === "Yes" ? true : false, // ✅ Updates status properly
                },
              },
            }))
          }
          defaultValue="Yes" // Set the default selected value
        >
          {["Yes", "No"].map((item, index) => (
            <FormControlLabel
              key={index}
              control={<Radio value={item} disabled={disabled} />}
              label={item}
            />
          ))}
        </RadioGroup>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "bold",
            marginTop: "1rem",
            textIndent: "-1rem",
            marginLeft: "2rem",
          }}
          gutterBottom
        >
          d. Do the employees/ worker of the entity have access to
          non-occupational medical and healthcare services?
        </Typography>
        <RadioGroup
          disabled={disabled}
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "0px",
            padding: "0px 5px",
            marginLeft: "2rem",
          }}
          value={
            formData?.healthAndSafetyManagement
              ?.nonOccupationalMedicalServicesAccess?.status === true
              ? "Yes"
              : "No"
          }
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              healthAndSafetyManagement: {
                ...prev.healthAndSafetyManagement,
                nonOccupationalMedicalServicesAccess: {
                  ...prev.healthAndSafetyManagement
                    .nonOccupationalMedicalServicesAccess,
                  status: e.target.value === "Yes" ? true : false, // ✅ Updates status properly
                },
              },
            }))
          }
          defaultValue="Yes" // Set the default selected value
        >
          {["Yes", "No"].map((item, index) => (
            <FormControlLabel
              key={index}
              control={<Radio value={item} disabled={disabled} />}
              label={item}
            />
          ))}
        </RadioGroup>
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "healthAndSafetyManagementDoc",
          ml: 3,
          removeUpload,
        }}
      />
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <Box sx={{ mt: 2 }}>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "bold",
            marginTop: "1rem",
            textIndent: "-1rem",
            marginLeft: "1rem",
          }}
          gutterBottom
        >
          11. Details of safety related incidents, in the following format:
        </Typography>
        <Box sx={{ marginLeft: "1.3rem" }}>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: "bold",
              marginTop: "1rem",
              marginBottom: "-0.9rem",
            }}
            gutterBottom
          >
            a.Employees
          </Typography>
          <Tables
            heading={safetyRelated}
            columnWidth={"40% 30% 30%"}
            disabled={disabled}
            // columnValue={columnValue}
            columnValue={generateColumnValue("WorkersEmployee")}
            // title={"Other than Permanent Workers"}
            formValues={formData}
            setFormValues={setFormData}
            setErrors={setErrors}
            errorsindex={rowindex}
            setRowIndex={setRowIndex}
            // errors={errors}
            errors={errors?.safetyIncidents?.filter((item) =>
              `${item.subkey}`.includes("employees"),
            )}
            // topHeading={"Permanent Employees"}
            // topheader={"20.Details at the end of Financial Year"}
          />
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: "bold",
              marginTop: "1rem",
              marginBottom: "-0.9rem",
            }}
            gutterBottom
          >
            b.Workers
          </Typography>
          <Tables
            heading={safetyRelated}
            columnWidth={"40% 30% 30%"}
            disabled={disabled}
            // columnValue={columnValue}
            columnValue={generateColumnValue("WorkersEmployeeEleventh")}
            // title={"Other than Permanent Workers"}
            formValues={formData}
            setFormValues={setFormData}
            setErrors={setErrors}
            errorsindex={rowindex}
            setRowIndex={setRowIndex}
            errors={errors?.safetyIncidents?.filter((item) =>
              `${item.subkey}`.includes("workers"),
            )}
            // topHeading={"Permanent Employees"}
            // topheader={"20.Details at the end of Financial Year"}
          />
        </Box>
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "safetyIncidentsDoc",
          ml: 3,
          removeUpload,
        }}
      />

      <Box sx={{ mt: 2 }}>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "bold",
            marginTop: "2rem",
            textIndent: "-1rem",
            marginLeft: "1rem",
          }}
          gutterBottom
        >
          12. Describe the measures taken by the entity to ensure a safe and
          healthy work place.
        </Typography>
        <TextField
          placeholder="Type"
          disabled={disabled}
          multiline
          rows={3}
          sx={{ marginLeft: "1rem" }}
          value={formData?.safetyMeasures}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              safetyMeasures: e.target.value,
            }))
          }
          fullWidth
        />
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "ssafetyMeasuresDoc",
          ml: 3,
          removeUpload,
        }}
      />
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <Box sx={{ mt: 2 }}>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "bold",
            marginTop: "2rem",
            textIndent: "-1rem",
            marginLeft: "1rem",
          }}
          gutterBottom
        >
          13. Number of Complaints on the following made by employees and
          workers:
        </Typography>
        <Box sx={{ marginLeft: "1.3rem" }}>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: "bold",
              marginTop: "1rem",
              marginBottom: "-1rem",
              textIndent: "-1rem",
              marginLeft: "1rem",
            }}
            gutterBottom
          >
            a.Current Financial Year
          </Typography>
          <Tables
            heading={headingNumber}
            columnWidth={"26% 25% 25% 24%"}
            // columnValue={columnValue}
            columnValue={generateColumnValue("NumberOfComplaints")}
            // title={"Other than Permanent Workers"}
            formValues={formData}
            setFormValues={setFormData}
            setErrors={setErrors}
            errorsindex={rowindex}
            disabled={disabled}
            setRowIndex={setRowIndex}
            // errors={errors}
            errors={errors?.complaintsMadeByEmployeesAndWorkers?.filter(
              (item) => `${item.subkey}`.includes("currentFinancialYear"),
            )}
            // topHeading={"Permanent Employees"}
            // topheader={"20.Details at the end of Financial Year"}
          />
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: "bold",
              marginTop: "1rem",
              marginBottom: "-1rem",
              textIndent: "-1rem",
              marginLeft: "1rem",
            }}
            gutterBottom
          >
            b.Previous Financial Year
          </Typography>
          <Tables
            heading={headingNumber}
            disabled={disabled}
            columnWidth={"26% 25% 25% 24%"}
            // columnValue={columnValue}
            columnValue={generateColumnValue("NumberOfComplaints13")}
            // title={"Other than Permanent Workers"}
            formValues={formData}
            setFormValues={setFormData}
            setErrors={setErrors}
            errorsindex={rowindex}
            setRowIndex={setRowIndex}
            errors={errors?.complaintsMadeByEmployeesAndWorkers?.filter(
              (item) => `${item.subkey}`.includes("previousFinancialYear"),
            )}
            // topHeading={"Permanent Employees"}
            // topheader={"20.Details at the end of Financial Year"}
          />
        </Box>
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "complaintsMadeByEmployeesAndWorkersDoc",
          ml: 3,
          removeUpload,
        }}
      />
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <Box sx={{ mt: 2 }}>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "bold",
            marginTop: "2rem",
            marginBottom: "-1rem",
            textIndent: "-1rem",
            marginLeft: "1rem",
          }}
          gutterBottom
        >
          14. Assessments for the year:
        </Typography>

        <Tables
          heading={headingAssessment}
          columnWidth={"25% 75%"}
          // columnValue={columnValue}
          columnValue={generateColumnValue("AssessmentsYear")}
          // title={"Other than Permanent Workers"}
          formValues={formData}
          setFormValues={setFormData}
          setErrors={setErrors}
          errorsindex={rowindex}
          setRowIndex={setRowIndex}
          errors={errors?.assessmentYear}
          disabled={disabled}

          // topHeading={"Permanent Employees"}
          // topheader={"20.Details at the end of Financial Year"}
        />
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "assessmentYearDoc",
          ml: 3,
          removeUpload,
        }}
      />
      <Box sx={{ mt: 2 }}>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "bold",
            marginTop: "2rem",
            textIndent: "-1rem",
            marginLeft: "1rem",
          }}
          gutterBottom
        >
          15.Provide details of any corrective action taken or underway to
          address safety-related incidents (if any) and on significant risks /
          concerns arising from assessments of health & safety practices and
          working conditions.
        </Typography>
        <TextField
          placeholder="Type"
          disabled={disabled}
          sx={{ marginLeft: "1.2rem", width: "98%" }}
          multiline
          rows={3}
          value={formData?.healthAndSafetyPracticesWorking}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              healthAndSafetyPracticesWorking: e.target.value,
            }))
          }
          fullWidth
        />
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "healthAndSafetyPracticesWorkingDoc",
          ml: 2.5,
          removeUpload,
        }}
      />
      {!hide && (
        <>
          {brsrReview ? (
            <Box sx={{ width: "98%", ml: 2.5 }}>
              <ReviewBox
                url={`/brsr/review/${id}`}
                handleSubmit={handleClick}
              />
            </Box>
          ) : (
            <Box textAlign="right" sx={{ mt: 3 }}>
              <Button
                variant="contained"
                sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
                onClick={handleClick}
              >
                Save & Continue <EastIcon sx={{ ml: 2 }} />
              </Button>
            </Box>
          )}
        </>
      )}
    </div>
  );
};

export default EssentialIndicator;